import React, { useEffect } from 'react';
import svgpanzoom from 'svg-pan-zoom';
import './DeviceGlobalStyle.css';
import './Alpha2Ver4DeviceStyle.css';
import { getSequenceName } from '../../utils';
import get from 'lodash.get';
let schematicDiagram = null;

const styleSensorRed = 'ver1-sen-red';
const styleSensorOrange = 'ver1-sen-amber';
const styleSensorGreen = 'ver1-sen-green_dark';
const styleSensorWhite = 'ver1-sen-white';
const styleSensorYellow = 'ver1-sen-yellow';

const styleLineBlueDark = 'ver1-line-blue_dark';
const styleLineReset = 'ver1-line-reset';

const tankFillColor = 'clsTankWater';




const DeviceSchematicAlpha2SvgVer4 = sensorData => {
  //Ball valves
  //===========
  let { ShowSensors, componentsInfo, siteAssociations, unitId, resetDiagram } = sensorData;

  let clsshow_sensor = ShowSensors ? 'show-sensor' : 'hide-sensor';
  const svgElement = document.querySelector('#dv-schematics');
  var options = {
    zoomEnabled: true,
    mouseWheelZoomEnabled: sensorData.enableMouseZoom,
    controlIconsEnabled: true,

    fit: true,
    center: true,
    contain: true
  };

  if (svgElement) {
    schematicDiagram = svgpanzoom(svgElement, options);

    if (sensorData.enableMouseZoom) {
      schematicDiagram.enableMouseWheelZoom();
    } else {
      schematicDiagram.disableMouseWheelZoom();
    }
  }

  const onResize = () => {
    if (schematicDiagram) {
      // schematicDiagram.reset();
      schematicDiagram.resize();
    }
  };

  useEffect(() => {
    window.addEventListener('resize', onResize);
  }, [onResize]); // Only initialize listener on initial render


  useEffect(() => {
    if (resetDiagram && schematicDiagram) {
      schematicDiagram.reset();
    }
  }, [resetDiagram]);

  // Current State
  let sequenceState = sensorData && sensorData.SensorData && sensorData.SensorData && sensorData.SensorData.current_state;

  // valve state data

  // Helper function to get valve state
  const getValveState = (valveName) => {
    const valveData = sensorData?.SensorData;
    if (!valveData) return null;

    if (valveData[`${valveName}_undefined`] === 1) return 'undefined';
    if (valveData[`${valveName}_closed`] === 1 && valveData[`${valveName}_open`] === 1) return 'undefined';
    if (valveData[`${valveName}_closed`] === 1) return 'closed';
    if (valveData[`${valveName}_open`] === 1) return 'open';

    return null;
  };

  const getSensorValue = (sensorName) => {
    const sensorInfo = sensorData?.SensorData;
    if (!sensorInfo) return null;
    return sensorInfo[sensorName] ?? '';
  };

  const getGeneralSensorStyle = (val) => {
    return val === undefined
      ? styleSensorOrange
      : val === 0
        ? ''
        : val === 1
          ? styleSensorGreen
          : styleSensorWhite;
  }

  const getValveStyle = (val) => {
    return val === undefined
      ? styleSensorOrange
      : val === 'closed'
        ? styleLineReset
        : val === 'open'
          ? styleSensorGreen
          : styleSensorOrange;
  }

  const getUoM = (sensorName) => {
    const sensor = componentsInfo.find(comp => comp.Name === sensorName.toUpperCase());
    return sensor ? sensor.UoM : '';
  }

  const getTitle = (sensorName) => {
    const sensor = componentsInfo.find(comp => comp.Name === sensorName.toUpperCase());
    return sensor ? toTitleCase(sensor.Title) : '';
  }

  const toTitleCase = (str) => {
    return str
      .toLowerCase()
      .replace(/\b\w/g, c => c.toUpperCase());
  }

  // Apply to all valves
  const vmt101 = getValveState('vmt101');
  const vmt102 = getValveState('vmt102');
  const vmt103 = getValveState('vmt103');
  const vmt104 = getValveState('vmt104');
  const vmt105 = getValveState('vmt105');
  const vmt106 = getValveState('vmt106');
  const vmt107 = getValveState('vmt107');
  const vmt108 = getValveState('vmt108');
  const vmt109 = getValveState('vmt109');
  const vmt110 = getValveState('vmt110');
  const vmt111 = getValveState('vmt111');
  const vmt112 = getValveState('vmt112');
  const vmt113 = getValveState('vmt113');
  const vmt114 = getValveState('vmt114');
  const vmt115 = getValveState('vmt115');
  const vmt116 = getValveState('vmt116');
  const vmt117 = getValveState('vmt117');
  const vmt118 = getValveState('vmt118');
  const vmt119 = getValveState('vmt119');
  const vmt120 = getValveState('vmt120');

  const dsw101 = getValveState('dsw101');


  // Sensor data


  let fcb101_foulingcondition = getSensorValue('fcb101_foulingcondition');
  let fcb101_pressurediff = getSensorValue('fcb101_pressurediff');
  let fsm101_pressurediff = getSensorValue('fsm101_pressurediff');
  let fsm102_pressurediff = getSensorValue('fsm102_pressurediff');
  let fsm102_foulingcondition = getSensorValue('fsm102_foulingcondition');
  let fsm103_pressurediff = getSensorValue('fsm103_pressurediff');
  let fsm103_foulingcondition = getSensorValue('fsm103_foulingcondition');
  let fuf101_foulingcondition = getSensorValue('fuf101_foulingcondition');
  let fuf101_tmp = getSensorValue('fuf101_tmp');
  let fuf101_tcsf = getSensorValue('fuf101_tcsf');
  let pfl101_running = getSensorValue('pfl101_running');
  let pfl101_warningraw = getSensorValue('pfl101_warningraw');
  let pfl101_alarmraw = getSensorValue('pfl101_alarmraw');
  let pfl101_speed = getSensorValue('pfl101_speed');
  let pch101_running = getSensorValue('pch101_running');
  let sct101_conductivity = getSensorValue('sct101_conductivity');
  let sct101_totaldissolvedsolids = getSensorValue('sct101_totaldissolvedsolids');
  let sct102_conductivity = getSensorValue('sct102_conductivity');
  let sct102_totaldissolvedsolids = getSensorValue('sct102_totaldissolvedsolids');
  let sft101_alarmraw = getSensorValue('sft101_alarmraw');
  let sft101_flowrate = getSensorValue('sft101_flowrate');
  let sft101_foulingcondition = getSensorValue('sft101_foulingcondition');
  let spt101_pressure = getSensorValue('spt101_pressure');
  let spt102_pressure = getSensorValue('spt102_pressure');
  let spt103_pressure = getSensorValue('spt103_pressure');
  let spt104_pressure = getSensorValue('spt104_pressure');
  let spt105_pressure = getSensorValue('spt105_pressure');
  let spt106_pressure = getSensorValue('spt106_pressure');
  let spt107_pressure = getSensorValue('spt107_pressure');
  let spt108_pressure = getSensorValue('spt108_pressure');
  let spt109_pressure = getSensorValue('spt109_pressure');
  let spt110_pressure = getSensorValue('spt110_pressure');
  let spt111_pressure = getSensorValue('spt111_pressure');
  let spt112_pressure = getSensorValue('spt112_pressure');
  let stu101_turbidity = getSensorValue('stu101_turbidity');
  let stu101_foulingdrynesserror = getSensorValue('stu101_foulingdrynesserror');
  let stu102_turbidity = getSensorValue('stu102_turbidity');
  let stu102_foulingdrynesserror = getSensorValue('stu102_foulingdrynesserror');
  let tnk101_volume = getSensorValue('tnk101_volume');
  let tnk102_volume = getSensorValue('tnk102_volume');
  let uvm101_running = getSensorValue('uvm101_running');
  let uvm101_treating = getSensorValue('uvm101_treating');
  let uvm101_warningraw = getSensorValue('uvm101_warningraw');
  let uvm101_lampliferemaining = getSensorValue('uvm101_lampliferemaining');
  let uvm101_alarmraw = getSensorValue('uvm101_alarmraw');
  let uvm101_dose = getSensorValue('uvm101_dose');
  let uvm101_uvt = getSensorValue('uvm101_uvt');
  let pch101_speed = pch101_running == 1 ? getSensorValue('pch101_speed') : 0;

  let uvm101_status = uvm101_running === 1 ? 'Running' : uvm101_treating === 1 ? 'Treating' : 'Standby';

  let fcb101_pressurediff_title = getTitle('fcb101_pressurediff'),
    fsm101_pressurediff_title = getTitle('fsm101_pressurediff'),
    fsm102_pressurediff_title = getTitle('fsm102_pressurediff'),
    fuf101_tcsf_title = getTitle('fuf101_tcsf'),
    fuf101_tmp_title = getTitle('fuf101_tmp'),
    pch101_speed_title = getTitle('pch101_speed'),
    pfl101_speed_title = getTitle('pfl101_speed'),
    sct101_conductivity_title = getTitle('sct101_conductivity'),
    sct101_totaldissolvedsolids_title = getTitle('sct101_totaldissolvedsolids'),
    sct102_conductivity_title = getTitle('sct102_conductivity'),
    sct102_totaldissolvedsolids_title = getTitle('sct102_totaldissolvedsolids'),
    sft101_flowrate_title = getTitle('sft101_flowrate'),
    spt101_pressure_title = getTitle('spt101_pressure'),
    spt102_pressure_title = getTitle('spt102_pressure'),
    spt103_pressure_title = getTitle('spt103_pressure'),
    spt104_pressure_title = getTitle('spt104_pressure'),
    spt105_pressure_title = getTitle('spt105_pressure'),
    spt106_pressure_title = getTitle('spt106_pressure'),
    spt107_pressure_title = getTitle('spt107_pressure'),
    spt108_pressure_title = getTitle('spt108_pressure'),
    spt110_pressure_title = getTitle('spt110_pressure'),
    spt111_pressure_title = getTitle('spt111_pressure'),
    spt112_pressure_title = getTitle('spt112_pressure'),
    stu101_turbidity_title = getTitle('stu101_turbidity'),
    stu102_turbidity_title = getTitle('stu102_turbidity'),
    tnk101_volume_title = getTitle('tnk101_volume'),
    tnk102_volume_title = getTitle('tnk102_volume'),
    uvm101_dose_title = getTitle('uvm101_dose'),
    uvm101_lampliferemaining_title = getTitle('uvm101_lampliferemaining'),
    uvm101_status_title = getTitle('uvm101_status'),
    uvm101_uvt_title = getTitle('uvm101_uvt');


  let clstnk102_sump_body = '',
    clstnk102_sump_path_1 = '',
    clstnk101_sump_body = '',
    clstnk101_sump_path_1 = '',
    tnk103_fill_value = '',
    clsvnr105_group = '',
    clsvnr105_body = '',
    clsvnr105_path_1_1 = '',
    clsvnr105_path_1_2 = '',
    clsvnr105_path_2_1 = '',
    clsspt105_pressure_body = '',
    clsspt105_pressure_path_1 = '',
    clsspt108_pressure_body = '',
    clsspt108_pressure_path_1 = '',
    clsuvm101_status_body = '',
    clsuvm101_status_path_1 = '',
    clssct102_conductivity_body = '',
    clssct102_conductivity_path_1 = '',
    clssct102_totaldissolvedsolids_body = '',
    clssct102_totaldissolvedsolids_path_1 = '',
    clspch101_speed_body = '',
    clspch101_speed_path_1 = '',
    clsvar103_body = '',
    clsvar103_path_1 = '',
    clsvar103_path_2 = '',
    clsvar103_path_3 = '',
    clsdynamicconnector1680_body = '',
    clsdynamicconnector1680_path_1 = '',
    clsdynamicconnector1680_path_2 = '',
    clsenclosure_door_body = '',
    clsenclosure_door_1_body = '',
    clsair_con_body = '',
    clsair_con_1_body = '';




  // tank sensor data
  let tnk101_capacity = 40;
  let tnk101 = sensorData && sensorData.SensorData && sensorData.SensorData.tnk101_volume;
  let tnk101_schematic_max_overlay_height = 80;
  let tnk101_value = ShowSensors ? (tnk101 != null ? tnk101 : 'N/A') : 'TNK101';

  let tnk101_fill_value = 0;
  if (tnk101 != null && !isNaN(tnk101) && tnk101 > 0) {
    tnk101_fill_value = tnk101_schematic_max_overlay_height * (tnk101 / tnk101_capacity);
    if (tnk101_fill_value > 0) {
      clstnk101_sump_path_1 = tankFillColor;
    }
    if (tnk101_fill_value > 100) {
      tnk101_fill_value = 100;
    }
  }

  let tnk102_capacity = 65;

  let tnk102 = sensorData && sensorData.SensorData && sensorData.SensorData.tnk102_volume;
  let tnk102_schematic_max_overlay_height = 100;
  let tnk102_value = ShowSensors ? (tnk102 != null ? tnk102 : 'N/A') : 'TNK102';
  let tnk102_fill_value = 0;
  if (tnk102 != null && !isNaN(tnk102) && tnk102 > 0) {
    tnk102_fill_value = tnk102_schematic_max_overlay_height * (tnk102 / tnk102_capacity);
    if (tnk102_fill_value > 0) {
      clstnk102_sump_path_1 = tankFillColor;
    }
    if (tnk102_fill_value > 100) {
      tnk102_fill_value = 100;
    }
  }


  let tnk104_capacity = 20;
  let tnk104_schematic_overlay_height = 11;
  let tnk104 = sensorData && sensorData.SensorData && sensorData.SensorData.tnk104_volume;
  let tnk104_value = ShowSensors ? (tnk104 != null ? tnk104 : '') : 'TNK104';
  let tnk104_fill_value = !isNaN(tnk104) ? (tnk104_schematic_overlay_height / tnk104_capacity) * tnk104 : 0;
  if (tnk104_fill_value > tnk104_schematic_overlay_height) tnk104_fill_value = tnk104_schematic_overlay_height;
  if (tnk104_fill_value < 0) tnk104_fill_value = 0;


  let enc101_dooropen = getSensorValue('enc101_dooropen') == 1 ? "Open" : getSensorValue('enc101_dooropen') === 0 ? "Closed" : "Unknown";
  let enc101_leak = getSensorValue('enc101_leak') == 1 ? "Leak Detected" : "No Leak Detected";
  let stt101_temperature = getSensorValue('stt101_temperature');
  let stt102_temperature = getSensorValue('stt102_temperature');
  let stt103_temperature = getSensorValue('stt103_temperature');
  let sjt101_power = getSensorValue('sjt101_power');
  let acu101_cooling = getSensorValue('acu101_cooling') == 1 ? "Cooling" : getSensorValue('acu101_cooling') === 0 ? "Idle" : "Unknown";

  if (enc101_dooropen === "Unknown") {
    clsenclosure_door_body = 'hide-sensor';
    clsenclosure_door_1_body = 'hide-sensor';
  }

  if (acu101_cooling === "Unknown") {
    clsair_con_body = 'hide-sensor';
    clsair_con_1_body = 'hide-sensor';
  }



  let clsdrain1_path_3 = "";
  let clsdrain1_path_4 = "";
  let clsdrain1_path_5 = "";
  let clsdrain1_path_6 = "";
  let clsdrain1_path_7 = "";
  let clsdrain1_path_9 = "";
  let clsdrain1_path_10 = "";
  let clsdrain1_path_11 = "";
  let clsdrain1_path_12 = "";
  let clsdrain1_path_13 = "";
  let clsdrain1_path_14 = "";
  let clsdrain1_path_15 = "";
  let clsdrain1_path_16 = "";

  let clsdrain2_path_5 = "";
  let clsdrain2_path_6 = "";
  let clsdrain2_path_7 = "";
  let clsdrain2_path_8 = "";

  let uvm101_Treating = "";





  // colour the valves
  let clsvmt101_body = getValveStyle(vmt101);
  let clsvmt102_body = getValveStyle(vmt102);
  let clsvmt103_body = getValveStyle(vmt103);
  let clsvmt104_body = getValveStyle(vmt104);
  let clsvmt105_body = getValveStyle(vmt105);
  let clsvmt106_body = getValveStyle(vmt106);
  let clsvmt107_body = getValveStyle(vmt107);
  let clspoweredvalve1120_group = getValveStyle(vmt108);
  let clsvmt109_body = getValveStyle(vmt109);
  let clsvmt110_body = getValveStyle(vmt110);
  let clsvmt111_body = getValveStyle(vmt111);
  let clsvmt112_body = getValveStyle(vmt112);
  let clsvmt113_body = getValveStyle(vmt113);
  let clsvmt114_body = getValveStyle(vmt114);
  let clsvmt115_body = getValveStyle(vmt115);
  let clsvmt116_body = getValveStyle(vmt116);
  let clsvmt117_body = getValveStyle(vmt117);
  let clsvmt118_body = getValveStyle(vmt118);
  let clsvmt119_body = getValveStyle(vmt119);
  let clsvmt120_body = getValveStyle(vmt120);
  let clsdsw101_body = getValveStyle(dsw101);



  let clsspt101_body = '';
  let clsspt10y_body = '';
  let clsspt103_body = '';
  let clsspt103_line = '';
  let clsspt106_body = '';
  let clsspt106_line = '';
  let clsspt109_body = '';
  let clsspt110_body = '';
  let clsspt111_body = '';
  let clsspt112_body = '';
  let clsspt113_body = '';
  let clsspt102_body = '';
  let clsspt114_body = '';
  let clsstu102_body = '';
  let clsftr101_body = '';
  let clsftr102_body = '';
  let clsftr103_body = '';
  let clssct101_body = '';
  let clssct102_body = '';
  let clsacp101_body = '';
  let clsttr101_body = '';
  let clsstu101_body = '';
  let clsspt105_body = '';
  let clsspt104_body = '';
  let clsspt107_body = '';
  let clsspt108_body = '';
  let clsuvm101_body = '';



  let clsvnr104_body = '';
  let clsvnr108_body = '';


  let clsvnr107_body = '';

  let clsvnr102_body = '';
  let clsvnr106_body = '';
  let clsvnr103_body = '';
  let clsvnr101_body = '';






  let clsvmt101_fsm101_path_1 = vmt101 == 'open' ? styleLineBlueDark : '';
  let clsvmt101_fsm101_path_2 = clsvmt101_fsm101_path_1;
  let clsvmt101_fsm101_path_3 = clsvmt101_fsm101_path_1;
  let clsfsm101_body = '';
  let clsfsm101_path_1 = 'clsfsm101_path_1';
  let clsfsm101_path_2 = 'clsfsm101_path_2';
  let clsfsm101_path_3 = 'clsfsm101_path_3';
  let clsfsm101_path_4 = 'clsfsm101_path_4';
  let clsfsm101_path_5 = 'clsfsm101_path_5';
  let clsfsm101_path_6 = 'clsfsm101_path_6';
  let clsfsm101_vmt102_path_1 = vmt101 == 'open' ? styleLineBlueDark : '';
  let clsdrain1_path_1 = vmt102 == 'open' && clsfsm101_vmt102_path_1 != '' ? styleLineBlueDark : '';
  let clsdrain1_path_8 = clsdrain1_path_1;

  let clsfsm101_pressurediff_body = 'clsfsm101_pressurediff_body';
  let clsfsm101_pressurediff_path_1 = 'clsfsm101_pressurediff_path_1';
  let clsfsm101_vfl101_body = 'clsfsm101_vfl101_body';
  let clsfsm101_vfl101_path_1 = clsvmt101_fsm101_path_3;
  let clsfsm101_vfl101_path_2 = clsvmt101_fsm101_path_3;
  let clsfsm101_vmt102_body = 'clsfsm101_vmt102_body';
  let clstnk101_vmt103_body = 'clstnk101_vmt103_body';
  let clstnk101_vmt103_path_1 = tnk101_volume > 0 ? styleLineBlueDark : '';
  let clsdrain1_path_2 = vmt103 == 'open' ? clstnk101_vmt103_path_1 : '';

  let clstnk101_vmt118_body = 'clstnk101_vmt118_body';
  let clstnk101_vmt118_path_1 = clstnk101_vmt103_path_1;
  let clstnk101_vmt118_path_2 = clstnk101_vmt118_path_1;
  let clstnk101_vmt118_path_3 = clstnk101_vmt118_path_2;
  let clstnk101_vmt118_path_4 = clstnk101_vmt118_path_3;
  let clstnk101_vmt118_path_5 = clstnk101_vmt118_path_4;
  let clstnk101_vmt118_path_6 = clstnk101_vmt118_path_5;
  let clstnk102_vnr102_body = tnk102 > 0 ? styleLineBlueDark : '';
  let clstnk102_vnr102_path_1 = clstnk102_vnr102_body;
  let clstnk102_vnr102_path_2 = clstnk102_vnr102_path_1;
  let clstnk102_vnr102_path_3 = clstnk102_vnr102_path_2;
  let clstnk102_vnr102_path_4 = clstnk102_vnr102_path_3;
  let clsvnr102vnr104_vmt117_body = clstnk102_vnr102_path_4;
  let clsvnr102vnr104_vmt117_path_2 = clsvnr102vnr104_vmt117_body;
  let clsvnr102vnr104_vmt117_path_1 = '';
  let clspch101_vnr104_path_1 = '';
  let clsair_con_1_path_1 = 'clsair_con_1_path_1';
  let clsair_con_path_1 = 'clsair_con_path_1';
  let clsair_par101_body = 'clsair_par101_body';
  let clsair_par101_path_1 = 'clsair_par101_path_1';
  let clsair_par101_path_2 = 'clsair_par101_path_2';
  let clsair_par102_body = 'clsair_par102_body';
  let clsair_par102_path_1 = 'clsair_par102_path_1';
  let clsair_tnk101_1_body = 'clsair_tnk101_1_body';
  let clsair_tnk101_1_path_1 = 'clsair_tnk101_1_path_1';
  let clsair_tnk101_2_body = 'clsair_tnk101_2_body';
  let clsair_tnk101_2_path_1 = 'clsair_tnk101_2_path_1';
  let clsair_tnk101_2_path_2 = 'clsair_tnk101_2_path_2';
  let clsair_tnk101_body = 'clsair_tnk101_body';
  let clsair_tnk101_path_1 = 'clsair_tnk101_path_1';
  let clsair_tnk101_path_2 = 'clsair_tnk101_path_2';
  let clsambientair2_body = 'clsambientair2_body';
  let clsambientair2_group = 'clsambientair2_group';
  let clsambientair2_path_2_1 = 'clsambientair2_path_2_1';
  let clsambientair_body = 'clsambientair_body';
  let clsambientair_group = 'clsambientair_group';
  let clsambientair_par101_body = 'clsambientair_par101_body';
  let clsambientair_par101_path_1 = 'clsambientair_par101_path_1';
  let clsambientair_path_2_1 = 'clsambientair_path_2_1';
  let clsaux_components_body = 'clsaux_components_body';
  let clsaux_components_path_1 = 'clsaux_components_path_1';
  let clscheckvalve1192_body = 'clscheckvalve1192_body';
  let clscheckvalve1192_group = 'clscheckvalve1192_group';
  let clscheckvalve1192_path_1_1 = 'clscheckvalve1192_path_1_1';
  let clscheckvalve1192_path_1_2 = 'clscheckvalve1192_path_1_2';
  let clscheckvalve1192_path_2_1 = 'clscheckvalve1192_path_2_1';
  let clsclp101_body = 'clsclp101_body';
  let clsclp101_fuf101_body = 'clsclp101_fuf101_body';
  let clsclp101_fuf101_path_1 = 'clsclp101_fuf101_path_1';
  let clsclp101_fuf101_path_2 = 'clsclp101_fuf101_path_2';
  let clsclp101_fuf101_path_3 = 'clsclp101_fuf101_path_3';
  let clsclp101_path_1 = 'clsclp101_path_1';
  let clsclp101_path_2 = 'clsclp101_path_2';
  let clscolumn1092_body = 'clscolumn1092_body';
  let clscolumn1092_path_1 = 'clscolumn1092_path_1';
  let clsdrain1_body = 'clsdrain1_body';
  let clsdrain1_path_10a = 'clsdrain1_path_10a';
  let clsdrain1_path_10b = 'clsdrain1_path_10b';
  let clsdrain1_path_11a = 'clsdrain1_path_11a';
  let clsdrain1_path_11b = 'clsdrain1_path_11b';
  let clsdrain1_path_2a = 'clsdrain1_path_2a';
  let clsdrain1_path_3a = 'clsdrain1_path_3a';
  let clsdrain1_path_7a = 'clsdrain1_path_7a';
  let clsdrain1_path_7b = 'clsdrain1_path_7b';
  let clsdrain1_path_8a = 'clsdrain1_path_8a';
  let clsdrain1_path_8b = 'clsdrain1_path_8b';
  let clsdrain1_path_9a = 'clsdrain1_path_9a';
  let clsdrain1_path_9b = 'clsdrain1_path_9b';
  let clsdrain2_body = 'clsdrain2_body';
  let clsdrain2_path_1 = 'clsdrain2_path_1';
  let clsdrain2_path_2 = 'clsdrain2_path_2';
  let clsdrain2_path_3 = 'clsdrain2_path_3';
  let clsdrain2_path_4 = 'clsdrain2_path_4';
  let clsdrain_output_body = 'clsdrain_output_body';
  let clsdrain_output_path_1 = 'clsdrain_output_path_1';
  let clsdrain_output_path_2 = 'clsdrain_output_path_2';
  let clsdrain_output_path_3 = 'clsdrain_output_path_3';
  let clsdrainwater_body = 'clsdrainwater_body';
  let clsdrainwater_group = 'clsdrainwater_group';
  let clsdrainwater_path_2_1 = 'clsdrainwater_path_2_1';
  let clsdynamicconnector1574_body = 'clsdynamicconnector1574_body';
  let clsdynamicconnector1574_path_1 = 'clsdynamicconnector1574_path_1';
  let clsenclosure_door_1_path_1 = 'clsenclosure_door_1_path_1';
  let clsenclosure_door_path_1 = 'clsenclosure_door_path_1';
  let clsenclosure_sump_1_body = 'clsenclosure_sump_1_body';
  let clsenclosure_sump_1_path_1 = 'clsenclosure_sump_1_path_1';
  let clsenclosure_sump_body = 'clsenclosure_sump_body';
  let clsenclosure_sump_path_1 = 'clsenclosure_sump_path_1';
  let clsenclosure_temp_1_body = 'clsenclosure_temp_1_body';
  let clsenclosure_temp_1_path_1 = 'clsenclosure_temp_1_path_1';
  let clsenclosure_temp_body = 'clsenclosure_temp_body';
  let clsenclosure_temp_path_1 = 'clsenclosure_temp_path_1';
  let clsenclosuresump2_body = 'clsenclosuresump2_body';
  let clsenclosuresump2_group = 'clsenclosuresump2_group';
  let clsenclosuresump2_path_2_1 = 'clsenclosuresump2_path_2_1';
  let clsenclosuresump_body = 'clsenclosuresump_body';
  let clsenclosuresump_path_1 = 'clsenclosuresump_path_1';
  let clsfcb101_body = 'clsfcb101_body';
  let clsfcb101_path_1 = 'clsfcb101_path_1';
  let clsfcb101_path_2 = 'clsfcb101_path_2';
  let clsfcb101_path_3 = 'clsfcb101_path_3';
  let clsfcb101_path_4 = 'clsfcb101_path_4';
  let clsfcb101_path_5 = 'clsfcb101_path_5';
  let clsfcb101_path_6 = 'clsfcb101_path_6';
  let clsfcb101_pressurediff_body = 'clsfcb101_pressurediff_body';
  let clsfcb101_pressurediff_path_1 = 'clsfcb101_pressurediff_path_1';
  let clsfcb101_vnr108_body = 'clsfcb101_vnr108_body';
  let clsfcb101_vnr108_path_1 = 'clsfcb101_vnr108_path_1';
  let clsfsm102_body = 'clsfsm102_body';
  let clsfsm102_fsm103_body = 'clsfsm102_fsm103_body';
  let clsfsm102_fsm103_path_1 = 'clsfsm102_fsm103_path_1';
  let clsfsm102_fsm103_path_2 = 'clsfsm102_fsm103_path_2';
  let clsfsm102_path_1 = 'clsfsm102_path_1';
  let clsfsm102_path_2 = 'clsfsm102_path_2';
  let clsfsm102_path_3 = 'clsfsm102_path_3';
  let clsfsm102_path_4 = 'clsfsm102_path_4';
  let clsfsm102_path_5 = 'clsfsm102_path_5';
  let clsfsm102_path_6 = 'clsfsm102_path_6';
  let clsfsm102_pressurediff_body = 'clsfsm102_pressurediff_body';
  let clsfsm102_pressurediff_path_1 = 'clsfsm102_pressurediff_path_1';
  let clsfsm102_vmt105_body = 'clsfsm102_vmt105_body';
  let clsfsm102_vmt105_path_1 = 'clsfsm102_vmt105_path_1';
  let clsfsm103_body = 'clsfsm103_body';
  let clsfsm103_path_1 = 'clsfsm103_path_1';
  let clsfsm103_path_2 = 'clsfsm103_path_2';
  let clsfsm103_path_3 = 'clsfsm103_path_3';
  let clsfsm103_path_4 = 'clsfsm103_path_4';
  let clsfsm103_path_5 = 'clsfsm103_path_5';
  let clsfsm103_path_6 = 'clsfsm103_path_6';
  let clsfsm103_vmt106_body = 'clsfsm103_vmt106_body';
  let clsfsm103_vmt106_path_1 = 'clsfsm103_vmt106_path_1';
  let clsfsm103_vmt108_body = 'clsfsm103_vmt108_body';
  let clsfsm103_vmt108_path_1 = 'clsfsm103_vmt108_path_1';
  let clsfuf101_body = 'clsfuf101_body';
  let clsfuf101_path_1 = 'clsfuf101_path_1';
  let clsfuf101_path_2 = 'clsfuf101_path_2';
  let clsfuf101_path_3 = 'clsfuf101_path_3';
  let clsfuf101_path_4 = 'clsfuf101_path_4';
  let clsfuf101_path_5 = 'clsfuf101_path_5';
  let clsfuf101_path_6 = 'clsfuf101_path_6';
  let clsfuf101_tcsf_body = 'clsfuf101_tcsf_body';
  let clsfuf101_tcsf_path_1 = 'clsfuf101_tcsf_path_1';
  let clsfuf101_tmp_body = 'clsfuf101_tmp_body';
  let clsfuf101_tmp_path_1 = 'clsfuf101_tmp_path_1';
  let clsfuf101_vmt104_body = 'clsfuf101_vmt104_body';
  let clsfuf101_vmt104_path_1 = 'clsfuf101_vmt104_path_1';
  let clsfuf101_vmt104_path_2 = 'clsfuf101_vmt104_path_2';
  let clsfuf101_vmt107_body = 'clsfuf101_vmt107_body';
  let clsfuf101_vmt107_path_1 = 'clsfuf101_vmt107_path_1';
  let clsfuf101_vmt109vmt112_body = 'clsfuf101_vmt109vmt112_body';
  let clsfuf101_vmt109vmt112_path_1 = 'clsfuf101_vmt109vmt112_path_1';
  let clsfuf101_vmt109vmt112_path_10 = 'clsfuf101_vmt109vmt112_path_10';
  let clsfuf101_vmt109vmt112_path_11 = 'clsfuf101_vmt109vmt112_path_11';
  let clsfuf101_vmt109vmt112_path_2 = '';
  let clsfuf101_vmt109vmt112_path_3 = '';
  let clsfuf101_vmt109vmt112_path_4 = 'clsfuf101_vmt109vmt112_path_4';
  let clsfuf101_vmt109vmt112_path_5 = 'clsfuf101_vmt109vmt112_path_5';
  let clsfuf101_vmt109vmt112_path_6 = 'clsfuf101_vmt109vmt112_path_6';
  let clsfuf101_vmt109vmt112_path_7 = 'clsfuf101_vmt109vmt112_path_7';
  let clsfuf101_vmt109vmt112_path_8 = 'clsfuf101_vmt109vmt112_path_8';
  let clsfuf101_vmt109vmt112_path_9 = '';
  let clshighpressureservicingwater_body = 'clshighpressureservicingwater_body';
  let clshighpressureservicingwater_group = 'clshighpressureservicingwater_group';
  let clshighpressureservicingwater_path_2_1 = 'clshighpressureservicingwater_path_2_1';
  let clsinput_water_temp_1_body = 'clsinput_water_temp_1_body';
  let clsinput_water_temp_1_path_1 = 'clsinput_water_temp_1_path_1';
  let clsinput_water_temp_body = 'clsinput_water_temp_body';
  let clsinput_water_temp_path_1 = 'clsinput_water_temp_path_1';
  let clsinputwater_body = 'clsinputwater_body';
  let clsinputwater_group = 'clsinputwater_group';
  let clsinputwater_path_2_1 = 'clsinputwater_path_2_1';
  let clsinputwater_vhv101_body = 'clsinputwater_vhv101_body';
  let clsinputwater_vhv101_path_1 = '';
  let clsjunction1583_body = 'clsjunction1583_body';
  let clsjunction1585_body = 'clsjunction1585_body';
  let clsmajorpipeline1215_body = 'clsmajorpipeline1215_body';
  let clsmajorpipeline1215_path_1 = 'clsmajorpipeline1215_path_1';
  let clsmajorpipeliner1132_body = 'clsmajorpipeliner1132_body';
  let clsmajorpipeliner1132_path_1 = 'clsmajorpipeliner1132_path_1';
  let clsoutputwater_body = 'clsoutputwater_body';
  let clsoutputwater_group = 'clsoutputwater_group';
  let clsoutputwater_path_2_1 = 'clsoutputwater_path_2_1';
  let clspar101_body = 'clspar101_body';
  let clspar101_clp101_body = 'clspar101_clp101_body';
  let clspar101_clp101_path_1 = 'clspar101_clp101_path_1';
  let clspar101_clp101_path_2 = 'clspar101_clp101_path_2';
  let clspar101_clp101_path_3 = 'clspar101_clp101_path_3';
  let clspar101_path_1 = 'clspar101_path_1';
  let clspar101_path_2 = 'clspar101_path_2';
  let clspar101_path_3 = 'clspar101_path_3';
  let clspar101_path_4 = 'clspar101_path_4';
  let clspar101_path_5 = 'clspar101_path_5';
  let clspar101_path_6 = 'clspar101_path_6';
  let clspar101_path_7 = 'clspar101_path_7';
  let clspar101_path_8 = 'clspar101_path_8';
  let clspar101_path_9 = 'clspar101_path_9';
  let clspar102_body = 'clspar102_body';
  let clspar102_path_1 = 'clspar102_path_1';
  let clspar102_path_2 = 'clspar102_path_2';
  let clspar102_path_3 = 'clspar102_path_3';
  let clspar102_path_4 = 'clspar102_path_4';
  let clspar102_path_5 = 'clspar102_path_5';
  let clspar102_path_6 = 'clspar102_path_6';
  let clspar102_vnr106_body = 'clspar102_vnr106_body';
  let clspar102_vnr106_path_1 = 'clspar102_vnr106_path_1';
  let clspch101_IF = 'clspch101_IF';
  let clspfl101_body = '';
  let clspch101_body = '';
  let clspch101_path_1 = 'clspch101_path_1';
  let clspch101_path_2 = 'clspch101_path_2';
  let clspch101_path_3 = 'clspch101_path_3';
  let clspch101_path_4 = 'clspch101_path_4';
  let clspch101_path_5 = 'clspch101_path_5';
  let clspch101_vnr104_body = 'clspch101_vnr104_body';
  let clspfl101_all_body = 'clspfl101_all_body';
  let clspfl101_all_path_1 = 'clspfl101_all_path_1';
  let clspfl101_all_path_2 = 'clspfl101_all_path_2';
  let clspfl101_all_path_3 = 'clspfl101_all_path_3';
  let clspfl101_all_path_4 = 'clspfl101_all_path_4';
  let clspfl101_all_path_5 = 'clspfl101_all_path_5';
  let clspfl101_all_path_6 = '';
  let clspfl101_all_path_7 = '';
  let clspfl101_all_path_8 = '';
  let clspfl101_path_1 = 'clspfl101_path_1';
  let clspfl101_path_2 = 'clspfl101_path_2';
  let clspfl101_path_3 = 'clspfl101_path_3';
  let clspfl101_path_4 = 'clspfl101_path_4';
  let clspfl101_path_5 = 'clspfl101_path_5';
  let clspfl101_path_6 = 'clspfl101_path_6';
  let clspfl101_speed_body = 'clspfl101_speed_body';
  let clspfl101_speed_path_1 = 'clspfl101_speed_path_1';
  let clspower_consumption_1_body = 'clspower_consumption_1_body';
  let clspower_consumption_1_path_1 = 'clspower_consumption_1_path_1';
  let clspower_consumption_body = 'clspower_consumption_body';
  let clspower_consumption_path_1 = 'clspower_consumption_path_1';
  let clspoweredvalve1120_body = 'clspoweredvalve1120_body';
  let clspoweredvalve1120_path_1_1 = 'clspoweredvalve1120_path_1_1';
  let clspoweredvalve1120_path_1_2 = 'clspoweredvalve1120_path_1_2';
  let clspoweredvalve1120_path_1_3 = 'clspoweredvalve1120_path_1_3';
  let clspoweredvalve1120_path_2_1 = 'clspoweredvalve1120_path_2_1';
  let clsprocess_water_temp_1_body = 'clsprocess_water_temp_1_body';
  let clsprocess_water_temp_1_path_1 = 'clsprocess_water_temp_1_path_1';
  let clsprocess_water_temp_body = 'clsprocess_water_temp_body';
  let clsprocess_water_temp_path_1 = 'clsprocess_water_temp_path_1';
  let clssamplewater2_body = 'clssamplewater2_body';
  let clssamplewater2_group = 'clssamplewater2_group';
  let clssamplewater2_path_2_1 = 'clssamplewater2_path_2_1';
  let clssamplewater_body = 'clssamplewater_body';
  let clssamplewater_group = 'clssamplewater_group';
  let clssamplewater_path_2_1 = 'clssamplewater_path_2_1';
  let clssct101_conductivity_body = 'clssct101_conductivity_body';
  let clssct101_conductivity_path_1 = 'clssct101_conductivity_path_1';
  let clssct101_group = 'clssct101_group';
  let clssct101_path_2_1 = 'clssct101_path_2_1';
  let clssct101_totaldissolvedsolids_body = 'clssct101_totaldissolvedsolids_body';
  let clssct101_totaldissolvedsolids_path_1 = 'clssct101_totaldissolvedsolids_path_1';
  let clssct102_group = 'clssct102_group';
  let clssct102_path_2_1 = 'clssct102_path_2_1';
  let clssft101_body = 'clssft101_body';
  let clssft101_flowrate_body = 'clssft101_flowrate_body';
  let clssft101_flowrate_path_1 = 'clssft101_flowrate_path_1';
  let clssft101_group = 'clssft101_group';
  let clssft101_path_2_1 = 'clssft101_path_2_1';
  let clsspt101_group = 'clsspt101_group';
  let clsspt101_path_2_1 = 'clsspt101_path_2_1';
  let clsspt101_pressure_body = 'clsspt101_pressure_body';
  let clsspt101_pressure_path_1 = 'clsspt101_pressure_path_1';
  let clsspt102_group = 'clsspt102_group';
  let clsspt102_path_2_1 = 'clsspt102_path_2_1';
  let clsspt102_pressure_body = 'clsspt102_pressure_body';
  let clsspt102_pressure_path_1 = 'clsspt102_pressure_path_1';
  let clsspt103_group = 'clsspt103_group';
  let clsspt103_path_2_1 = 'clsspt103_path_2_1';
  let clsspt103_pressure_body = 'clsspt103_pressure_body';
  let clsspt103_pressure_path_1 = 'clsspt103_pressure_path_1';
  let clsspt104_group = 'clsspt104_group';
  let clsspt104_path_2_1 = 'clsspt104_path_2_1';
  let clsspt104_pressure_body = 'clsspt104_pressure_body';
  let clsspt104_pressure_path_1 = 'clsspt104_pressure_path_1';
  let clsspt105_group = 'clsspt105_group';
  let clsspt105_path_2_1 = 'clsspt105_path_2_1';
  let clsspt106_group = 'clsspt106_group';
  let clsspt106_path_2_1 = 'clsspt106_path_2_1';
  let clsspt106_pressure_body = 'clsspt106_pressure_body';
  let clsspt106_pressure_path_1 = 'clsspt106_pressure_path_1';
  let clsspt107_group = 'clsspt107_group';
  let clsspt107_path_2_1 = 'clsspt107_path_2_1';
  let clsspt107_pressure_body = 'clsspt107_pressure_body';
  let clsspt107_pressure_path_1 = 'clsspt107_pressure_path_1';
  let clsspt108_group = 'clsspt108_group';
  let clsspt108_path_2_1 = 'clsspt108_path_2_1';
  let clsspt110_group = 'clsspt110_group';
  let clsspt110_path_2_1 = 'clsspt110_path_2_1';
  let clsspt110_pressure_body = 'clsspt110_pressure_body';
  let clsspt110_pressure_path_1 = 'clsspt110_pressure_path_1';
  let clsspt111_group = 'clsspt111_group';
  let clsspt111_path_2_1 = 'clsspt111_path_2_1';
  let clsspt111_pressure_body = 'clsspt111_pressure_body';
  let clsspt111_pressure_path_1 = 'clsspt111_pressure_path_1';
  let clsspt112_group = 'clsspt112_group';
  let clsspt112_path_2_1 = 'clsspt112_path_2_1';
  let clsspt112_pressure_body = 'clsspt112_pressure_body';
  let clsspt112_pressure_path_1 = 'clsspt112_pressure_path_1';
  let clsssw102_body = 'clsssw102_body';
  let clsssw102_group = 'clsssw102_group';
  let clsssw102_path_2_1 = 'clsssw102_path_2_1';
  let clsstu101_group = 'clsstu101_group';
  let clsstu101_path_2_1 = 'clsstu101_path_2_1';
  let clsstu101_turbidity_body = 'clsstu101_turbidity_body';
  let clsstu101_turbidity_path_1 = 'clsstu101_turbidity_path_1';
  let clsstu102_group = 'clsstu102_group';
  let clsstu102_path_2_1 = 'clsstu102_path_2_1';
  let clsstu102_turbidity_body = 'clsstu102_turbidity_body';
  let clsstu102_turbidity_path_1 = 'clsstu102_turbidity_path_1';
  let clssump_body = 'clssump_body';
  let clssump_path_1 = 'clssump_path_1';
  let clssump_path_2 = 'clssump_path_2';
  let clstnk101_body = 'clstnk101_body';
  let clstnk101_drain_body = 'clstnk101_drain_body';
  let clstnk101_drain_path_1 = 'clstnk101_drain_path_1';
  let clstnk101_drain_path_2 = 'clstnk101_drain_path_2';
  let clstnk101_path_1 = 'clstnk101_path_1';
  let clstnk101_volume_body = 'clstnk101_volume_body';
  let clstnk101_volume_path_1 = 'clstnk101_volume_path_1';
  let clstnk102_body = 'clstnk102_body';
  let clstnk102_drain_body = 'clstnk102_drain_body';
  let clstnk102_drain_path_1 = 'clstnk102_drain_path_1';
  let clstnk102_drain_path_2 = 'clstnk102_drain_path_2';
  let clstnk102_path_1 = 'clstnk102_path_1';
  let clstnk102_volume_body = 'clstnk102_volume_body';
  let clstnk102_volume_path_1 = 'clstnk102_volume_path_1';
  let clstnk103_body = 'clstnk103_body';
  let clstnk103_path_1 = 'clstnk103_path_1';
  let clstnk103_pch101_body = 'clstnk103_pch101_body';
  let clstnk103_pch101_path_1 = 'clstnk103_pch101_path_1';
  let clsuvm101_dose_body = 'clsuvm101_dose_body';
  let clsuvm101_dose_path_1 = 'clsuvm101_dose_path_1';
  let clsuvm101_lampliferemaining_body = 'clsuvm101_lampliferemaining_body';
  let clsuvm101_lampliferemaining_path_1 = 'clsuvm101_lampliferemaining_path_1';
  let clsuvm101_path_1 = 'clsuvm101_path_1';
  let clsuvm101_uvt_body = 'clsuvm101_uvt_body';
  let clsuvm101_uvt_path_1 = 'clsuvm101_uvt_path_1';
  let clsuvm101_vmt114vmt116_body = 'clsuvm101_vmt114vmt116_body';
  let clsuvm101_vmt114vmt116_path_1 = 'clsuvm101_vmt114vmt116_path_1';
  let clsuvm101_vmt114vmt116_path_2 = 'clsuvm101_vmt114vmt116_path_2';
  let clsuvm101_vmt114vmt116_path_3 = 'clsuvm101_vmt114vmt116_path_3';
  let clsuvm101_vmt114vmt116_path_4 = 'clsuvm101_vmt114vmt116_path_4';
  let clsuvm101_vmt114vmt116_path_5 = 'clsuvm101_vmt114vmt116_path_5';
  let clsuvm101_vmt114vmt116_path_6 = 'clsuvm101_vmt114vmt116_path_6';
  let clsuvm101_vmt114vmt116_path_7 = 'clsuvm101_vmt114vmt116_path_7';
  let clsvar1011530_body = 'clsvar1011530_body';
  let clsvar1011530_path_1 = 'clsvar1011530_path_1';
  let clsvar1011530_path_2 = 'clsvar1011530_path_2';
  let clsvar1011530_path_3 = 'clsvar1011530_path_3';
  let clsvar101_body = 'clsvar101_body';
  let clsvar101_path_1 = 'clsvar101_path_1';
  let clsvar101_path_2 = 'clsvar101_path_2';
  let clsvar101_path_3 = 'clsvar101_path_3';
  let clsvar102_body = 'clsvar102_body';
  let clsvar102_path_1 = 'clsvar102_path_1';
  let clsvar102_path_2 = 'clsvar102_path_2';
  let clsvar102_path_3 = 'clsvar102_path_3';
  let clsvfl101_body = 'clsvfl101_body';
  let clsvfl101_group = 'clsvfl101_group';
  let clsvfl101_path_2_1 = 'clsvfl101_path_2_1';
  let clsvfl101_path_2_2 = 'clsvfl101_path_2_2';
  let clsvfl101_path_2_3 = 'clsvfl101_path_2_3';
  let clsvfl101_path_2_4 = 'clsvfl101_path_2_4';
  let clsvhv101_body = 'clsvhv101_body';
  let clsvhv101_path_1 = 'clsvhv101_path_1';
  let clsvhv101_path_2 = 'clsvhv101_path_2';
  let clsvhv101_path_3 = 'clsvhv101_path_3';
  let clsvhv101_path_4 = 'clsvhv101_path_4';
  let clsvhv101_vmt101_body = 'clsvhv101_vmt101_body';
  let clsvhv101_vmt101_path_1 = '';
  let clsvhv101_vmt101_path_2 = 'clsvhv101_vmt101_path_2';
  let clsvhv102_body = 'clsvhv102_body';
  let clsvhv102_path_1 = 'clsvhv102_path_1';
  let clsvhv102_path_2 = 'clsvhv102_path_2';
  let clsvhv102_path_3 = 'clsvhv102_path_3';
  let clsvhv102_path_4 = 'clsvhv102_path_4';
  let clsvhv102_sample_body = 'clsvhv102_sample_body';
  let clsvhv102_sample_path_1 = 'clsvhv102_sample_path_1';
  let clsvhv103_body = 'clsvhv103_body';
  let clsvhv103_path_1 = 'clsvhv103_path_1';
  let clsvhv103_path_2 = 'clsvhv103_path_2';
  let clsvhv103_path_3 = 'clsvhv103_path_3';
  let clsvhv103_path_4 = 'clsvhv103_path_4';
  let clsvhv1041512_body = 'clsvhv1041512_body';
  let clsvhv1041512_path_1 = 'clsvhv1041512_path_1';
  let clsvhv1041512_path_2 = 'clsvhv1041512_path_2';
  let clsvhv1041512_path_3 = 'clsvhv1041512_path_3';
  let clsvhv1041512_path_4 = 'clsvhv1041512_path_4';
  let clsvhv104_body = 'clsvhv104_body';
  let clsvhv104_path_1 = 'clsvhv104_path_1';
  let clsvhv104_path_2 = 'clsvhv104_path_2';
  let clsvhv104_path_3 = 'clsvhv104_path_3';
  let clsvhv104_path_4 = 'clsvhv104_path_4';
  let clsvhv104_sample_body = 'clsvhv104_sample_body';
  let clsvhv104_sample_path_1 = 'clsvhv104_sample_path_1';
  let clsvhv104_vnr107fuf101_body = 'clsvhv104_vnr107fuf101_body';
  let clsvhv104_vnr107fuf101_path_1 = 'clsvhv104_vnr107fuf101_path_1';
  let clsvhv104_vnr107fuf101_path_2 = 'clsvhv104_vnr107fuf101_path_2';
  let clsvmt101_fsm101_body = 'clsvmt101_fsm101_body';
  let clsvmt101_group = 'clsvmt101_group';
  let clsvmt101_path_1_1 = 'clsvmt101_path_1_1';
  let clsvmt101_path_1_2 = 'clsvmt101_path_1_2';
  let clsvmt101_path_1_3 = 'clsvmt101_path_1_3';
  let clsvmt101_path_2_1 = 'clsvmt101_path_2_1';
  let clsvmt102_group = 'clsvmt102_group';
  let clsvmt102_path_1_1 = 'clsvmt102_path_1_1';
  let clsvmt102_path_1_2 = 'clsvmt102_path_1_2';
  let clsvmt102_path_1_3 = 'clsvmt102_path_1_3';
  let clsvmt102_path_2_1 = 'clsvmt102_path_2_1';
  let clsvmt103_group = 'clsvmt103_group';
  let clsvmt103_path_1_1 = 'clsvmt103_path_1_1';
  let clsvmt103_path_1_2 = 'clsvmt103_path_1_2';
  let clsvmt103_path_1_3 = 'clsvmt103_path_1_3';
  let clsvmt103_path_2_1 = 'clsvmt103_path_2_1';
  let clsvmt104_group = 'clsvmt104_group';
  let clsvmt104_path_1_1 = 'clsvmt104_path_1_1';
  let clsvmt104_path_1_2 = 'clsvmt104_path_1_2';
  let clsvmt104_path_1_3 = 'clsvmt104_path_1_3';
  let clsvmt104_path_2_1 = 'clsvmt104_path_2_1';
  let clsvmt105_group = 'clsvmt105_group';
  let clsvmt105_path_1_1 = 'clsvmt105_path_1_1';
  let clsvmt105_path_1_2 = 'clsvmt105_path_1_2';
  let clsvmt105_path_1_3 = 'clsvmt105_path_1_3';
  let clsvmt105_path_2_1 = 'clsvmt105_path_2_1';
  let clsvmt106_group = 'clsvmt106_group';
  let clsvmt106_path_1_1 = 'clsvmt106_path_1_1';
  let clsvmt106_path_1_2 = 'clsvmt106_path_1_2';
  let clsvmt106_path_1_3 = 'clsvmt106_path_1_3';
  let clsvmt106_path_2_1 = 'clsvmt106_path_2_1';
  let clsvmt107_group = 'clsvmt107_group';
  let clsvmt107_path_1_1 = 'clsvmt107_path_1_1';
  let clsvmt107_path_1_2 = 'clsvmt107_path_1_2';
  let clsvmt107_path_1_3 = 'clsvmt107_path_1_3';
  let clsvmt107_path_2_1 = 'clsvmt107_path_2_1';
  let clsvmt108_group = 'clsvmt108_group';
  let clsvmt108_path_1_1 = 'clsvmt108_path_1_1';
  let clsvmt108_path_1_2 = 'clsvmt108_path_1_2';
  let clsvmt108_path_1_3 = 'clsvmt108_path_1_3';
  let clsvmt108_path_2_1 = 'clsvmt108_path_2_1';
  let clsvmt109_group = 'clsvmt109_group';
  let clsvmt109_path_1_1 = 'clsvmt109_path_1_1';
  let clsvmt109_path_1_2 = 'clsvmt109_path_1_2';
  let clsvmt109_path_1_3 = 'clsvmt109_path_1_3';
  let clsvmt109_path_2_1 = 'clsvmt109_path_2_1';
  let clsvmt110_group = 'clsvmt110_group';
  let clsvmt110_path_1_1 = 'clsvmt110_path_1_1';
  let clsvmt110_path_1_2 = 'clsvmt110_path_1_2';
  let clsvmt110_path_1_3 = 'clsvmt110_path_1_3';
  let clsvmt110_path_2_1 = 'clsvmt110_path_2_1';
  let clsvmt111_group = 'clsvmt111_group';
  let clsvmt111_path_1_1 = 'clsvmt111_path_1_1';
  let clsvmt111_path_1_2 = 'clsvmt111_path_1_2';
  let clsvmt111_path_1_3 = 'clsvmt111_path_1_3';
  let clsvmt111_path_2_1 = 'clsvmt111_path_2_1';
  let clsvmt112_fcb101vhv105_body = 'clsvmt112_fcb101vhv105_body';
  let clsvmt112_fcb101vhv105_path_1 = 'clsvmt112_fcb101vhv105_path_1';
  let clsvmt112_fcb101vhv105_path_2 = 'clsvmt112_fcb101vhv105_path_2';
  let clsvmt112_fcb101vhv105_path_3 = 'clsvmt112_fcb101vhv105_path_3';
  let clsvmt112_fcb101vhv105_path_4 = 'clsvmt112_fcb101vhv105_path_4';
  let clsvmt112_group = 'clsvmt112_group';
  let clsvmt112_path_1_1 = 'clsvmt112_path_1_1';
  let clsvmt112_path_1_2 = 'clsvmt112_path_1_2';
  let clsvmt112_path_1_3 = 'clsvmt112_path_1_3';
  let clsvmt112_path_2_1 = 'clsvmt112_path_2_1';
  let clsvmt113_group = 'clsvmt113_group';
  let clsvmt113_path_1_1 = 'clsvmt113_path_1_1';
  let clsvmt113_path_1_2 = 'clsvmt113_path_1_2';
  let clsvmt113_path_1_3 = 'clsvmt113_path_1_3';
  let clsvmt113_path_2_1 = 'clsvmt113_path_2_1';
  let clsvmt114_group = 'clsvmt114_group';
  let clsvmt114_path_1_1 = 'clsvmt114_path_1_1';
  let clsvmt114_path_1_2 = 'clsvmt114_path_1_2';
  let clsvmt114_path_1_3 = 'clsvmt114_path_1_3';
  let clsvmt114_path_2_1 = 'clsvmt114_path_2_1';
  let clsvmt114_tnk102_body = 'clsvmt114_tnk102_body';
  let clsvmt114_tnk102_path_1 = 'clsvmt114_tnk102_path_1';
  let clsvmt115_group = 'clsvmt115_group';
  let clsvmt115_path_1_1 = 'clsvmt115_path_1_1';
  let clsvmt115_path_1_2 = 'clsvmt115_path_1_2';
  let clsvmt115_path_1_3 = 'clsvmt115_path_1_3';
  let clsvmt115_path_2_1 = 'clsvmt115_path_2_1';
  let clsvmt116_group = 'clsvmt116_group';
  let clsvmt116_path_1_1 = 'clsvmt116_path_1_1';
  let clsvmt116_path_1_2 = 'clsvmt116_path_1_2';
  let clsvmt116_path_1_3 = 'clsvmt116_path_1_3';
  let clsvmt116_path_2_1 = 'clsvmt116_path_2_1';
  let clsvmt117_group = 'clsvmt117_group';
  let clsvmt117_path_1_1 = 'clsvmt117_path_1_1';
  let clsvmt117_path_1_2 = 'clsvmt117_path_1_2';
  let clsvmt117_path_1_3 = 'clsvmt117_path_1_3';
  let clsvmt117_path_2_1 = 'clsvmt117_path_2_1';
  let clsvmt117vmt118_pfl101_body = 'clsvmt117vmt118_pfl101_body';
  let clsvmt117vmt118_pfl101_path_1 = '';
  let clsvmt117vmt118_pfl101_path_2 = '';
  let clsvmt118_group = 'clsvmt118_group';
  let clsvmt118_path_1_1 = 'clsvmt118_path_1_1';
  let clsvmt118_path_1_2 = 'clsvmt118_path_1_2';
  let clsvmt118_path_1_3 = 'clsvmt118_path_1_3';
  let clsvmt118_path_2_1 = 'clsvmt118_path_2_1';
  let clsvnr101_group = 'clsvnr101_group';
  let clsvnr101_path_1_1 = 'clsvnr101_path_1_1';
  let clsvnr101_path_1_2 = 'clsvnr101_path_1_2';
  let clsvnr101_path_2_1 = 'clsvnr101_path_2_1';
  let clsvnr102_group = 'clsvnr102_group';
  let clsvnr102_path_1_1 = 'clsvnr102_path_1_1';
  let clsvnr102_path_1_2 = 'clsvnr102_path_1_2';
  let clsvnr102_path_2_1 = 'clsvnr102_path_2_1';
  let clsvnr103_group = 'clsvnr103_group';
  let clsvnr103_path_1_1 = 'clsvnr103_path_1_1';
  let clsvnr103_path_1_2 = 'clsvnr103_path_1_2';
  let clsvnr103_path_2_1 = 'clsvnr103_path_2_1';
  let clsvnr104_group = 'clsvnr104_group';
  let clsvnr104_path_1_1 = 'clsvnr104_path_1_1';
  let clsvnr104_path_1_2 = 'clsvnr104_path_1_2';
  let clsvnr104_path_2_1 = 'clsvnr104_path_2_1';
  let clsvnr105_output_body = 'clsvnr105_output_body';
  let clsvnr105_output_path_1 = 'clsvnr105_output_path_1';
  let clsvnr106_group = 'clsvnr106_group';
  let clsvnr106_path_1_1 = 'clsvnr106_path_1_1';
  let clsvnr106_path_1_2 = 'clsvnr106_path_1_2';
  let clsvnr106_path_2_1 = 'clsvnr106_path_2_1';
  let clsvnr107_group = 'clsvnr107_group';
  let clsvnr107_path_1_1 = 'clsvnr107_path_1_1';
  let clsvnr107_path_1_2 = 'clsvnr107_path_1_2';
  let clsvnr107_path_2_1 = 'clsvnr107_path_2_1';
  let clsvnr108_group = 'clsvnr108_group';
  let clsvnr108_path_1_1 = 'clsvnr108_path_1_1';
  let clsvnr108_path_1_2 = 'clsvnr108_path_1_2';
  let clsvnr108_path_2_1 = 'clsvnr108_path_2_1';
  let clsvnr108_vmt113uvm101_body = 'clsvnr108_vmt113uvm101_body';
  let clsvnr108_vmt113uvm101_path_1 = 'clsvnr108_vmt113uvm101_path_1';
  let clsvnr108_vmt113uvm101_path_2 = '';
  let clsvmt108_vmt110_path_1 = 'clsvmt108_vmt110_path_1';
  let clsvmt108_vmt110_path_2 = 'clsvmt108_vmt110_path_2';
  let clsvmt108_vmt110_path_3 = 'clsvmt108_vmt110_path_3';
  let clsfuf101_all_lines = '';


  // Line Logics 



  if (clsdrain1_path_8 !== '') {
    clsdrain1_path_9 = clsdrain1_path_8;
  }

  if (clsdrain1_path_2 !== '') {
    clsdrain1_path_9 = clsdrain1_path_2;
  }

  if (vmt118 == 'open' || vmt117 == 'open') {
    clsvmt117vmt118_pfl101_path_1 = clstnk101_vmt118_path_6;
    clsvmt117vmt118_pfl101_path_2 = clsvmt117vmt118_pfl101_path_1;
    clspfl101_path_5 = clsvmt117vmt118_pfl101_path_2;

    if (vmt117 == 'open') {
      clsvmt117vmt118_pfl101_path_2 = clstnk102_vnr102_path_3;
      clspfl101_path_5 = clsvmt117vmt118_pfl101_path_2;
    }

  }




  if (pch101_running > 0) {
    clstnk103_pch101_path_1 = styleLineBlueDark;
    clspch101_path_4 = clstnk103_pch101_path_1;
    clspch101_path_5 = clspch101_path_4;
    clspch101_vnr104_path_1 = clspch101_path_5;
    clsvnr102vnr104_vmt117_path_1 = clspch101_vnr104_path_1;

  }

  if (pfl101_running > 0) {
    clspfl101_path_4 = clsvmt117vmt118_pfl101_path_2;
    clspfl101_all_path_1 = clspfl101_path_4;
    clspfl101_all_path_5 = clspfl101_path_4;
    clspfl101_all_path_4 = clspfl101_all_path_5;
    clspfl101_path_6 = clspfl101_all_path_4;
    clspfl101_all_path_2 = clspfl101_path_6;
    clspfl101_all_path_3 = clspfl101_all_path_2;
    clsfsm102_vmt105_path_1 = clspfl101_all_path_4;
    clsfsm102_fsm103_path_1 = clsfsm102_vmt105_path_1;
    clsfsm102_fsm103_path_2 = clsfsm102_fsm103_path_1;
    clsfsm103_vmt108_path_1 = clsfsm102_fsm103_path_1;
    clsfsm103_vmt106_path_1 = clsfsm102_fsm103_path_1;

  }

  if (vmt105 == 'open') {
    clsdrain1_path_3 = clsfsm102_vmt105_path_1;
    clsdrain1_path_12 = clsdrain1_path_3;
  }



  if (vmt108 == 'open') {
    clsvmt108_vmt110_path_1 = clsfsm103_vmt108_path_1;
    clsfuf101_all_lines = clsvmt108_vmt110_path_1;
  }


  if (vmt109 == 'open') {
    clspfl101_all_path_7 = clspfl101_all_path_1;
    clspfl101_all_path_6 = clspfl101_all_path_7;
    clsfuf101_all_lines = clspfl101_all_path_6;

  }


  if (vmt110 == 'open') {
    clsdrain1_path_5 = clsfuf101_all_lines;
    clsdrain1_path_14 = clsdrain1_path_5;
  }

  if (vmt106 == 'open') {
    clsdrain1_path_4 = clsfsm102_vmt105_path_1;
    clsdrain1_path_13 = clsdrain1_path_4;
  }
  if (vmt107 == 'open') {
    clsdrain1_path_6 = clsfuf101_all_lines;
    clsdrain1_path_15 = clsdrain1_path_6;
  }

  if (vmt104 == 'open') {
    clsdrain2_path_1 = clsfuf101_all_lines;
  }



  clsfuf101_vmt109vmt112_path_2 = clsfuf101_vmt109vmt112_path_2 == '' ? clsfuf101_vmt109vmt112_path_11 : clsfuf101_vmt109vmt112_path_2;
  clsfuf101_vmt109vmt112_path_9 = clsfuf101_vmt109vmt112_path_9 == '' ? clsfuf101_vmt109vmt112_path_11 : clsfuf101_vmt109vmt112_path_9;



  if (vmt112 == 'open') {
    clsvmt112_fcb101vhv105_path_2 = clsfuf101_all_lines;
    clsvmt112_fcb101vhv105_path_3 = clsvmt112_fcb101vhv105_path_2;
    clsvmt112_fcb101vhv105_path_4 = clsvmt112_fcb101vhv105_path_2;
    clsfcb101_vnr108_path_1 = clsvmt112_fcb101vhv105_path_4;
    clsvnr108_vmt113uvm101_path_2 = clsfcb101_vnr108_path_1;
    clsvnr108_vmt113uvm101_path_1 = clsvnr108_vmt113uvm101_path_2;
    clsuvm101_vmt114vmt116_path_4 = clsvnr108_vmt113uvm101_path_1;


  }

  if (vmt111 == 'open') {
    clsdrain2_path_4 = clsfuf101_all_lines;
    clsdrain2_path_6 = clsdrain2_path_4;
  }





  if (vmt113 == 'open') {
    clspfl101_all_path_7 = clspfl101_all_path_1;
    clspfl101_all_path_8 = clspfl101_all_path_7;
    clsvnr108_vmt113uvm101_path_2 = clspfl101_all_path_8
    clsvnr108_vmt113uvm101_path_1 = clspfl101_all_path_8;

  }


  clsdrain2_path_5 = clsdrain2_path_5 == '' ? clsdrain2_path_1 : clsdrain2_path_5;
  clsdrain2_path_6 = clsdrain2_path_6 == '' ? clsdrain2_path_5 : clsdrain2_path_6;
  clsdrain2_path_7 = clsdrain2_path_7 == '' ? clsdrain2_path_6 : clsdrain2_path_7;
  clsdrain2_path_8 = clsdrain2_path_8 == '' ? clsdrain2_path_7 : clsdrain2_path_8;




  clsuvm101_vmt114vmt116_path_4 = clsvnr108_vmt113uvm101_path_2;
  clsuvm101_vmt114vmt116_path_1 = clsuvm101_vmt114vmt116_path_4;
  clsuvm101_vmt114vmt116_path_2 = clsuvm101_vmt114vmt116_path_4;
  clsuvm101_vmt114vmt116_path_3 = clsuvm101_vmt114vmt116_path_4;

  clsuvm101_vmt114vmt116_path_5 = clsuvm101_vmt114vmt116_path_4;
  clsuvm101_vmt114vmt116_path_6 = clsuvm101_vmt114vmt116_path_4;
  clsuvm101_vmt114vmt116_path_7 = clsuvm101_vmt114vmt116_path_4;

  if (vmt115 == 'open') {
    clsdrain2_path_2 = clsuvm101_vmt114vmt116_path_6;
    clsdrain2_path_8 = clsdrain2_path_2;
  }
  if (vmt116 == 'open') {

    clsmajorpipeline1215_path_1 = clsuvm101_vmt114vmt116_path_7;
    clsdynamicconnector1574_path_1 = clsmajorpipeline1215_path_1;
    clsvnr105_output_path_1 = clsdynamicconnector1574_path_1;
    clsvhv102_sample_path_1 = clsdynamicconnector1574_path_1;
  }

  if (vmt114 == 'open') {
    clsvmt114_tnk102_path_1 = clsuvm101_vmt114vmt116_path_2
  }

  //Drain lines
  clsdrain1_path_10 = clsdrain1_path_10 == '' ? clsdrain1_path_9 : clsdrain1_path_10;
  clsdrain1_path_11 = clsdrain1_path_11 == '' ? clsdrain1_path_10 : clsdrain1_path_11;
  clsdrain1_path_12 = clsdrain1_path_12 == '' ? clsdrain1_path_11 : clsdrain1_path_12;
  clsdrain1_path_13 = clsdrain1_path_13 == '' ? clsdrain1_path_12 : clsdrain1_path_13;
  clsdrain1_path_14 = clsdrain1_path_14 == '' ? clsdrain1_path_13 : clsdrain1_path_14;
  clsdrain1_path_15 = clsdrain1_path_15 == '' ? clsdrain1_path_14 : clsdrain1_path_15;
  clsdrain1_path_16 = clsdrain1_path_16 == '' ? clsdrain1_path_15 : clsdrain1_path_16;


  clsdrain_output_path_1 = clsdrain2_path_8;

  if (clsdrain_output_path_1 == styleLineBlueDark) {
    clsdrain_output_path_2 = clsdrain_output_path_1;
  }

  if (clsdrain1_path_16 == styleLineBlueDark) {

    clsdrain_output_path_2 = clsdrain1_path_16;
  }

  clsdrain_output_path_3 = clsdrain_output_path_2;

  // Hide lines by default
  clsfuf101_vmt109vmt112_path_8 = 'hide-line';
  clsfuf101_vmt109vmt112_path_7 = 'hide-line';



  // Sensor logic styles

  if (pfl101_alarmraw >= 1) {
    clspfl101_body = styleSensorRed;
  }
  else if (pfl101_warningraw >= 1) {
    clspfl101_body = styleSensorOrange;
  }
  else {
    clspfl101_body = getGeneralSensorStyle(pfl101_running);
  }


  if (fsm102_foulingcondition < 25) {
    clsfsm102_body = styleSensorRed;
  }
  else if (fsm102_foulingcondition >= 25 && fsm102_foulingcondition < 50) {
    clsfsm102_body = styleSensorOrange;
  }
  else if (fsm102_foulingcondition >= 50 && fsm102_foulingcondition < 75) {
    clsfsm102_body = styleSensorYellow;
  }
  else {
    clsfsm102_body = styleSensorGreen;
  }

  if (fsm103_foulingcondition < 25) {
    clsfsm103_body = styleSensorRed;
  }
  else if (fsm103_foulingcondition >= 25 && fsm103_foulingcondition < 50) {
    clsfsm103_body = styleSensorOrange;
  }
  else if (fsm103_foulingcondition >= 50 && fsm103_foulingcondition < 75) {
    clsfsm103_body = styleSensorYellow;
  }
  else {
    clsfsm103_body = styleSensorGreen;
  }

  if (fuf101_foulingcondition < 25) {
    clsfuf101_body = styleSensorRed;
  }
  else if (fuf101_foulingcondition >= 25 && fuf101_foulingcondition < 50) {
    clsfuf101_body = styleSensorOrange;
  }
  else if (fuf101_foulingcondition >= 50 && fuf101_foulingcondition < 75) {
    clsfuf101_body = styleSensorYellow;
  }
  else {
    clsfuf101_body = styleSensorGreen;
  }


  if (fcb101_foulingcondition < 25) {
    clsfcb101_body = styleSensorRed;
  }
  else if (fcb101_foulingcondition >= 25 && fcb101_foulingcondition < 50) {
    clsfcb101_body = styleSensorOrange;
  }
  else if (fcb101_foulingcondition >= 50 && fcb101_foulingcondition < 75) {
    clsfcb101_body = styleSensorYellow;
  }
  else {
    clsfcb101_body = styleSensorGreen;
  }


  if (uvm101_alarmraw >= 1 || uvm101_lampliferemaining == 0) {
    clsuvm101_path_1 = styleSensorRed;
  }
  else if (uvm101_warningraw >= 1) {
    clsuvm101_path_1 = styleSensorOrange;
  }
  else {
    clsuvm101_path_1 = getGeneralSensorStyle(uvm101_running);
  }

  clspch101_body = getGeneralSensorStyle(pch101_running);
  clssft101_body = sft101_alarmraw >= 1 ? styleSensorRed : '';


  // clsstu101_body = stu101_foulingdrynesserror >= 1 ? styleSensorRed : '';
  // clsstu102_body = stu102_foulingdrynesserror >= 1 ? styleSensorRed : '';


  clsvnr102vnr104_vmt117_path_2 = clsvnr102vnr104_vmt117_path_1 || clstnk102_vnr102_path_3;



  const st1 = 'st1';
  const st10 = 'st10';
  const st11 = 'st11';
  const st12 = 'st12';
  const st13 = 'st13';
  const st14 = 'st14';
  const st15 = 'st15';
  const st16 = 'st16';
  const st17 = 'st17';
  const st18 = 'st18';
  const st19 = 'st19';
  const st2 = 'st2';
  const st20 = 'st20';
  const st21 = 'st21';
  const st22 = 'st22';
  const st3 = 'st3';
  const st4 = 'st4';
  const st5 = 'st5';
  const st6 = 'st6';
  const st7 = 'st7';
  const st8 = 'st8';
  const st9 = 'st9';
  const cls_def = 'cls_def'


  // UoM text after

  fcb101_pressurediff = `${fcb101_pressurediff} ${getUoM('fcb101_pressurediff')}`;
  fsm101_pressurediff = `${fsm101_pressurediff} ${getUoM('fsm101_pressurediff')}`;
  fsm102_pressurediff = `${fsm102_pressurediff} ${getUoM('fsm102_pressurediff')}`;
  fsm103_pressurediff = `${fsm103_pressurediff} ${getUoM('fsm103_pressurediff')}`;
  fuf101_tmp = `${fuf101_tmp} ${getUoM('fuf101_tmp')}`;
  fuf101_tcsf = `${fuf101_tcsf} ${getUoM('fuf101_tcsf')}`;
  pfl101_speed = `${pfl101_speed} ${getUoM('pfl101_speed')}`;
  sct101_conductivity = `${sct101_conductivity} ${getUoM('sct101_conductivity')}`;
  sct101_totaldissolvedsolids = `${sct101_totaldissolvedsolids} ${getUoM('sct101_totaldissolvedsolids')}`;
  sct102_conductivity = `${sct102_conductivity} ${getUoM('sct102_conductivity')}`;
  sct102_totaldissolvedsolids = `${sct102_totaldissolvedsolids} ${getUoM('sct102_totaldissolvedsolids')}`;
  sft101_flowrate = `${sft101_flowrate} ${getUoM('sft101_flowrate')}`;
  spt101_pressure = `${spt101_pressure} ${getUoM('spt101_pressure')}`;
  spt102_pressure = `${spt102_pressure} ${getUoM('spt102_pressure')}`;
  spt103_pressure = `${spt103_pressure} ${getUoM('spt103_pressure')}`;
  spt104_pressure = `${spt104_pressure} ${getUoM('spt104_pressure')}`;
  spt105_pressure = `${spt105_pressure} ${getUoM('spt105_pressure')}`;
  spt106_pressure = `${spt106_pressure} ${getUoM('spt106_pressure')}`;
  spt107_pressure = `${spt107_pressure} ${getUoM('spt107_pressure')}`;
  spt108_pressure = `${spt108_pressure} ${getUoM('spt108_pressure')}`;
  spt109_pressure = `${spt109_pressure} ${getUoM('spt109_pressure')}`;
  spt110_pressure = `${spt110_pressure} ${getUoM('spt110_pressure')}`;
  spt111_pressure = `${spt111_pressure} ${getUoM('spt111_pressure')}`;
  spt112_pressure = `${spt112_pressure} ${getUoM('spt112_pressure')}`;
  stu101_turbidity = `${stu101_turbidity} ${getUoM('stu101_turbidity')}`;
  stu102_turbidity = `${stu102_turbidity} ${getUoM('stu102_turbidity')}`;
  tnk101_volume = `${tnk101_volume} ${getUoM('tnk101_volume')}`;
  tnk102_volume = `${tnk102_volume} ${getUoM('tnk102_volume')}`;
  uvm101_dose = `${uvm101_dose} ${getUoM('uvm101_dose')}`;
  uvm101_uvt = `${uvm101_uvt} ${getUoM('uvm101_uvt')}`;
  uvm101_lampliferemaining = `${uvm101_lampliferemaining} ${getUoM('uvm101_lampliferemaining')}`;

  stt101_temperature = `${stt101_temperature} ${getUoM('stt101_temperature')}`;
  stt102_temperature = `${stt102_temperature} ${getUoM('stt102_temperature')}`;
  stt103_temperature = `${stt103_temperature} ${getUoM('stt103_temperature')}`;
  sjt101_power = `${sjt101_power} ${getUoM('sjt101_power')}`;


  pch101_speed = `${pch101_speed} ${getUoM('pch101_speed')}`;










  // BMS
  let bms101_volts = (sensorData && sensorData.SensorData && sensorData.SensorData.bms101_voltage) || '-';
  let bms101_grid1 = (sensorData && sensorData.SensorData && sensorData.SensorData.bms101_gridl1) || '-';
  let bms101_percentage = (sensorData && sensorData.SensorData && sensorData.SensorData.bms101_percentage) || '-';
  let bms101_percentage_value = (sensorData && sensorData.SensorData && sensorData.SensorData.bms101_percentage) || 0;
  let bms101_acco = (sensorData && sensorData.SensorData && sensorData.SensorData.bms101_accomsumption) || '-';

  let clsbms101_body = 'bms-body-empty';
  let clsbms101_25 = 'bms-empty ';
  let clsbms101_50 = 'bms-empty ';
  let clsbms101_75 = 'bms-empty ';
  let clsbms101_100 = 'bms-empty ';

  if (bms101_volts !== '-') bms101_volts += ' volts dc';
  if (bms101_grid1 !== '-') bms101_grid1 += ' watts';
  if (bms101_acco !== '-') bms101_acco += ' watts';
  if (bms101_percentage !== '-') bms101_percentage += ' %';

  // coloring BMS
  if (bms101_percentage_value) {
    if (bms101_percentage_value > 95) {
      clsbms101_body = 'bms-body-100';
      clsbms101_100 = 'bms-100';
      clsbms101_75 = clsbms101_100;
      clsbms101_50 = clsbms101_100;
      clsbms101_25 = clsbms101_100;
    } else if (bms101_percentage_value > 75) {
      clsbms101_body = 'bms-body-75';
      clsbms101_75 = 'bms-75';
      clsbms101_50 = clsbms101_75;
      clsbms101_25 = clsbms101_75;
    } else if (bms101_percentage_value > 50) {
      clsbms101_body = 'bms-body-50';
      clsbms101_50 = 'bms-50';
      clsbms101_25 = clsbms101_50;
    } else if (bms101_percentage_value > 0) {
      clsbms101_body = 'bms-body-25';
      clsbms101_25 = 'bms-25';
    } else {
    }
  } else {
    clsbms101_body = 'bms-body-empty';
    clsbms101_100 = 'bms-cell-empty';
    clsbms101_75 = clsbms101_100;
    clsbms101_50 = clsbms101_100;
    clsbms101_25 = clsbms101_100;
  }


  const gatewayInfo = (siteAssociations && siteAssociations.find(x => x.UnitId == unitId)) || null;
  let gatewaylink = gatewayInfo && gatewayInfo.GatewayId ? `/unit/process-flow/${gatewayInfo.GatewaySerialNumber}` : '';
  let gatewayUnit =
    gatewayInfo && gatewayInfo.GatewayId ? (
      <a id="gatewaylinkid" xlinkHref={gatewaylink}>
        <g
          id="g2-8"
          style={{
            fontSize: 12,
            overflow: 'visible',
            fill: 'none',
            fillRule: 'evenodd',
            strokeLinecap: 'square',
            strokeMiterlimit: 3
          }}
          transform="matrix(.2633 0 0 .28218 7.425 -64.396)"
        >
          <g id="deviceid" transform="matrix(1.2687 0 0 1.38668 -29.208 -311.231)">
            <g id="shape1280-25" transform="translate(112.188 -4.505)">
              <path
                d="M26.3 840.57v-21.12c0-.35-.16-.69-.43-.94s-.64-.38-1.03-.38H1.46c-.39 0-.76.13-1.03.38-.28.25-.43.59-.43.94v21.12c0 .35.15.69.43.93.27.25.64.39 1.03.39h23.38c.39 0 .76-.14 1.03-.39s.43-.58.43-.93zm-23.38-1.33v-3.62h9.99c.35.93 1.05 1.71 1.97 2.21a4.9 4.9 0 0 0 3.08.53c1.06-.16 2.03-.65 2.72-1.4.7-.74 1.08-1.69 1.08-2.66 0-.98-.39-1.92-1.08-2.67-.7-.74-1.66-1.24-2.72-1.4-1.07-.16-2.16.03-3.08.53-.92.5-1.62 1.29-1.97 2.21H2.92v-12.2h20.45v3.62H13.34c-.35-.93-1.05-1.71-1.97-2.21-.92-.5-2.01-.69-3.07-.53-1.07.16-2.03.65-2.73 1.4a3.9 3.9 0 0 0-1.07 2.66c0 .98.38 1.92 1.07 2.67.7.74 1.67 1.24 2.73 1.4 1.06.16 2.15-.03 3.07-.53.92-.5 1.62-1.29 1.97-2.21h10.03v12.2zm12.67-4.89c0-.29.09-.57.27-.81.18-.25.43-.43.73-.55.3-.11.62-.13.94-.08.31.06.6.2.83.4.22.21.38.47.44.76.06.28.03.58-.09.85s-.33.49-.6.66c-.27.16-.58.24-.9.24-.42-.01-.82-.17-1.12-.44a1.4 1.4 0 0 1-.46-1.03zm-4.97-8.69c0 .29-.09.58-.27.82-.18.24-.43.43-.73.54-.3.11-.62.14-.94.09-.31-.06-.6-.2-.83-.41-.23-.2-.38-.46-.44-.75-.07-.28-.03-.58.09-.85s.33-.5.6-.66c.27-.16.58-.25.9-.25.21 0 .43.03.63.1.21.07.39.18.54.32.16.14.28.3.37.48.08.18.12.38.12.57z"
                className="st10"
                id="path12-9"
                style={{
                  fill: 'none',
                  stroke: '#0a5487',
                  strokeWidth: 1.5,
                  strokeLinecap: 'butt'
                }}
              />
            </g>
            <g id="shape1281-27" transform="translate(18.262 1.264)">
              <path
                d="M90.348 805.595h4.38v-2.64h-4.38v-5.94c0-.26-.09-.51-.25-.73-.16-.22-.38-.39-.65-.49-.26-.1-.55-.12-.84-.07-.28.04-.54.17-.74.35l-14.39 13.02c-.27.26-.42.59-.43.94v33.21c0 .23.06.46.19.66.12.19.3.36.51.48l14.34 7.76c.22.12.47.18.73.18.25 0 .51-.06.73-.18.22-.12.4-.28.53-.49.13-.2.2-.43.2-.66v-5.7h4.38v-2.65h-4.38zm-2.92 43.09-11.47-6.13v-31.9l11.47-10.49z"
                className="st10"
                id="path13-1"
                style={{
                  fill: 'none',
                  stroke: '#0a5487',
                  strokeWidth: 1.5,
                  strokeLinecap: 'butt'
                }}
              />
            </g>
            <g id="shape1282-29" transform="translate(137.827 11.74)">
              <path
                d="M21.11 798.66 6.72 785.6a1.45 1.45 0 0 0-.75-.35c-.28-.05-.57-.03-.84.07-.26.1-.49.27-.65.49-.16.22-.24.47-.24.73v5.94H0v2.64h4.24v37.09H0v2.65h4.24v5.7c0 .23.06.46.19.66.13.21.31.37.54.49.22.12.47.18.73.18.25 0 .51-.06.73-.18l14.36-7.72c.22-.12.39-.29.52-.49.13-.19.19-.42.19-.65v-33.21c.01-.18-.02-.36-.08-.52a1.3 1.3 0 0 0-.31-.46zm-2.51 33.42-11.44 6.16v-48.55l11.47 10.42z"
                className="st10"
                id="path14-3"
                style={{
                  fill: 'none',
                  stroke: '#0a5487',
                  strokeWidth: 1.5,
                  strokeLinecap: 'butt'
                }}
              />
            </g>
            <g id="shape1283-31" transform="translate(127.6 4.688)">
              <path
                d="M5.84 839.24H0v2.65h5.84z"
                className="st10"
                id="path15-5"
                style={{
                  fill: 'none',
                  stroke: '#0a5487',
                  strokeWidth: 1.5,
                  strokeLinecap: 'butt'
                }}
              />
            </g>
            <g id="shape1284-33" transform="translate(117.374 4.688)">
              <path
                d="M5.84 839.24H0v2.65h5.84z"
                className="st10"
                id="path16-9"
                style={{
                  fill: 'none',
                  stroke: '#0a5487',
                  strokeWidth: 1.5,
                  strokeLinecap: 'butt'
                }}
              />
            </g>
            <g id="shape1285-35" transform="translate(127.6 -35.025)">
              <path
                d="M5.84 839.24H0v2.65h5.84z"
                className="st10"
                id="path17"
                style={{
                  fill: 'none',
                  stroke: '#0a5487',
                  strokeWidth: 1.5,
                  strokeLinecap: 'butt'
                }}
              />
            </g>
            <g id="shape1286-37" transform="translate(117.374 -35.025)">
              <path
                d="M5.84 839.24H0v2.65h5.84z"
                className="st10"
                id="path18-8"
                style={{
                  fill: 'none',
                  stroke: '#0a5487',
                  strokeWidth: 1.5,
                  strokeLinecap: 'butt'
                }}
              />
            </g>
          </g>
          <text
            id="deviceTextId"
            x={131.194}
            y={891.949}
            className="st6"
            style={{
              fontWeight: 700,
              fontSize: '13.9999px',
              fontFamily: 'Calibri',
              textAnchor: 'middle',
              fill: '#0a5487'
            }}
          >
            {gatewayInfo.GatewayName}
          </text>
          <text
            id="deviceTextId-1"
            x={132.492}
            y={786.16}
            className="st6"
            style={{
              fontWeight: 700,
              fontSize: '13.9999px',
              fontFamily: 'Calibri',
              textAnchor: 'middle',
              overflow: 'visible',
              fill: '#0a5487',
              fillRule: 'evenodd',
              strokeLinecap: 'square',
              strokeMiterlimit: 3
            }}
          >
            {'IoT Gateway'}
          </text>
          <rect
            style={{
              fill: '#000',
              fillOpacity: 0.01,
              stroke: '#0a5487',
              strokeWidth: 0.545485
            }}
            id="gatewayName"
            width={134.795}
            height={132.276}
            x={65.304}
            y={770.965}
            rx={1.906}
          />
        </g>
      </a>
    ) : (
      <></>
    );

  return (

    <svg id="dv-schematics" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 1138.92 594.527" xmlSpace="preserve" colorInterpolationFilters="sRGB" className={st22}>
      <defs>

        {/* Right arrow */}
        <marker
          id="arrow-right"
          viewBox="0 0 10 10"
          refX="2"
          refY="5"
          markerWidth="8"
          markerHeight="8"
          orient="auto"
        >
          <path d="M0 0 L10 5 L0 10 Z" fill="currentColor" />
        </marker>

        {/* Left arrow */}
        <marker
          id="arrow-left"
          viewBox="0 0 10 10"
          refX="6"
          refY="5"
          markerWidth="8"
          markerHeight="8"
          orient="auto"
        >
          <path d="M10 0 L0 5 L10 10 Z" fill="currentColor" />
        </marker>

        {/* Up arrow */}
        <marker
          id="arrow-up"
          viewBox="0 0 10 10"
          refX="5"
          refY="0"
          markerWidth="8"
          markerHeight="8"
          orient="auto"
        >
          <path d="M0 10 L5 0 L10 10 Z" fill="currentColor" />
        </marker>

        {/* Down arrow */}
        <marker
          id="arrow-down"
          viewBox="0 0 10 10"
          refX="5"
          refY="10"
          markerWidth="8"
          markerHeight="8"
          orient="auto"
        >
          <path d="M0 0 L5 10 L10 0 Z" fill="currentColor" />
        </marker>
      </defs>
      <g>
        <g id="tnk102_sump_body" transform="translate(287.029,-452.321)" className={clstnk102_sump_body}>
          <title>TNK102 Sump</title>
          <path d="M19.49 594.53 L6.73 594.53 L0 576.18 L19.49 576.18 L19.49 594.53 Z" className={`${st1} ${clstnk102_sump_path_1}`} />
        </g>
        <g id="tnk101_sump_body" transform="translate(287.029,-264.498)" className={clstnk101_sump_body}>
          <title>TNK101 Sump</title>
          <path d="M19.49 594.53 L6.73 594.53 L0 579.83 L19.49 579.83 L19.49 594.53 Z" className={`${st1} ${clstnk101_sump_path_1}`} />
        </g>
        <g id="tnk101_body" transform="translate(228.564,-278.624)" className={clstnk101_body}>
          {/* Fill indicator */}
          <rect
            x="0"
            y={594.53 - tnk101_fill_value}
            width="77.95"
            height={tnk101_fill_value}
            fill="#4A90E2"
            stroke="none"
          />
          <title>TNK101</title>
          <path d="M0 594.53 L58.46 594.53 L64.96 608.7 L77.95 608.7 L77.95 594.53 L77.95 509.49 L38.98 509.49 L0 509.49 L0 594.53        Z" className={`${st2} ${clstnk101_path_1}`} />
          <text x="30.59" y="507.04" className={st3}>TNK101</text>		</g>
        <g id="vmt101_group" transform="translate(101.005,-345.947)" className={clsvmt101_group}>
          <title>VMT101</title>
          <desc>VMT101</desc>
          <g id="vmt101_body_1" transform="translate(6.37795,-16.4764)" className={clsvmt101_body}>
            <path d="M0 594.53 L8.5 594.53 L8.5 586.02 L0 586.02 L0 594.53 Z" className={`${st4} ${clsvmt101_path_1_1}`} />
            <path d="M0 594.53 L8.5 594.53 L8.5 586.02 L0 586.02 L0 594.53" className={`${st5} ${clsvmt101_path_1_2}`} />
            <path d="M4.25 594.53 L4.25 600.37" className={`${st5} ${clsvmt101_path_1_3}`} />
          </g>
          <g id="vmt101_body_2" className={clsvmt101_body}>
            <path d="M0 589.21 L0 578.58 L21.26 589.21 L21.26 578.58 L0 589.21 Z" className={`${st2} ${clsvmt101_path_2_1}`} />
            <text x="1.05" y="595.9" className={st3}>VMT101</text>			</g>
        </g>
        <g id="vfl101_group" transform="translate(228.564,-343.821)" className={clsvfl101_group}>
          <title>VFL101</title>
          <g id="vfl101_body_1" transform="translate(12.7559,-12.7559)" className={clsvfl101_body}>
          </g>
          <g id="vfl101_body_2" className={clsvfl101_body}>
            <path d="M0 588.15 L25.51 575.39 L25.51 588.15 L0 575.39 L0 588.15 ZM16.58 591.34 A2.55118 2.55118 0 1 0 21.69 591.34         A2.55118 2.55118 0 1 0 16.58 591.34 Z" className={`${st4} ${clsvfl101_path_2_1}`} />
            <path d="M0 588.15 L25.51 575.39 L25.51 588.15 L0 575.39 L0 588.15" className={`${st5} ${clsvfl101_path_2_2}`} />
            <path d="M16.58 591.34 A2.55118 2.55118 0 1 0 21.69 591.34 A2.55118 2.55118 0 1 0 16.58 591.34" className={`${st5} ${clsvfl101_path_2_3}`} />
            <path d="M12.76 581.77 L12.76 586.87 L17.04 589.87" className={`${st5} ${clsvfl101_path_2_4}`} />
            <text x="2.44" y="598.88" className={st3}>VFL101</text>			</g>
        </g>
        <g id="vhv101_body" transform="translate(58.4852,-345.947)" className={clsvhv101_body}>
          <title>VHV101</title>
          <desc>VHV101</desc>
          <path d="M0 578.58 L0 589.21 L21.26 578.58 L21.26 589.21 L0 578.58 Z" className={`${st4} ${clsvhv101_path_1}`} />
          <path d="M0 578.58 L0 589.21 L21.26 578.58 L21.26 589.21 L0 578.58" className={`${st5} ${clsvhv101_path_2}`} />
          <path d="M10.63 583.9 L10.63 573.27" className={`${st5} ${clsvhv101_path_3}`} />
          <path d="M5.31 573.27 L15.94 573.27" className={`${st5} ${clsvhv101_path_4}`} />
          <text x="1.5" y="595.62" className={st3}>VHV101</text>		</g>
        <g id="inputwater_group" transform="translate(8.87893,-345.947)" className={clsinputwater_group}>
          <title>Input Water</title>
          <desc>INPUT WATER</desc>
          <g id="inputwater_body_1" transform="translate(21.2598,-10.6299)" className={clsinputwater_body}>
          </g>
          <g id="inputwater_body_2" className={clsinputwater_body}>
            <rect x="0" y="573.267" width="42.5197" height="21.2598" rx="10.6299" ry="10.6299" className={`${st2} ${clsinputwater_path_2_1}`} />
          </g>
          <g id="inputwater_body_3" className={clsinputwater_body}>
            <text x="5.63" y="585.1" className={st3}>INPUT <tspan x="11.62" dy="1.2em" className={st6}> </tspan>WATER</text>			</g>
        </g>
        <g id="inputwater_vhv101_body" transform="translate(47.8553,-363.663)" className={clsinputwater_vhv101_body}>
          <title>Input Water-VHV101</title>
          <path d="M3.54 601.61 L7.61 601.61" className={`${st7} ${clsinputwater_vhv101_path_1}`} markerEnd="url(#arrow-right)" />
        </g>
        <g id="fsm101_body" transform="translate(178.958,-342.404)" className={clsfsm101_body}>
          <title>FSM101</title>
          <desc>FSM101</desc>
          <path d="M0 594.53 L0 566.18 L14.17 566.18 L14.17 594.53 L0 594.53 Z" className={`${st4} ${clsfsm101_path_1}`} />
          <path d="M0 594.53 L0 566.18 L14.17 566.18 L14.17 594.53 L0 594.53" className={`${st5} ${clsfsm101_path_2}`} />
          <path d="M0 594.53 L2.03 590.47" className={`${st5} ${clsfsm101_path_3}`} />
          <path d="M3.49 587.55 L6.08 582.37" className={`${st5} ${clsfsm101_path_4}`} />
          <path d="M8.09 578.34 L10.12 574.29" className={`${st5} ${clsfsm101_path_5}`} />
          <path d="M12.15 570.23 L14.17 566.18" className={`${st5} ${clsfsm101_path_6}`} />
          <text x="-2.8" y="563.73" className={st3}>FSM101</text>		</g>
        <g id="vmt102_group" transform="translate(-397.852,372.596) rotate(-90)" className={clsvmt102_group}>
          <title>VMT102</title>
          <desc>VMT102</desc>
          <g id="vmt102_body_1" transform="translate(6.37795,-16.4764)" className={clsvmt102_body}>
            <path d="M0 594.53 L8.5 594.53 L8.5 586.02 L0 586.02 L0 594.53 Z" className={`${st4} ${clsvmt102_path_1_1}`} />
            <path d="M0 594.53 L8.5 594.53 L8.5 586.02 L0 586.02 L0 594.53" className={`${st5} ${clsvmt102_path_1_2}`} />
            <path d="M4.25 594.53 L4.25 600.37" className={`${st5} ${clsvmt102_path_1_3}`} />
          </g>
          <g id="vmt102_body_2" className={clsvmt102_body}>
            <path d="M0 589.21 L0 578.58 L21.26 589.21 L21.26 578.58 L0 589.21 Z" className={`${st2} ${clsvmt102_path_2_1}`} />
            <text x="590.5" y="-8.83" transform="rotate(90)" className={st3}>VMT102</text>			</g>
        </g>
        <g id="fsm101_vmt102_body" transform="translate(178.958,-342.404)" className={clsfsm101_vmt102_body}>
          <title>FSM101-VMT102</title>
          <path d="M7.09 594.53 L7.09 693.74" className={`${st5} ${clsfsm101_vmt102_path_1}`} />
        </g>
        <g id="vmt103_group" transform="translate(-284.467,372.596) rotate(-90)" className={clsvmt103_group}>
          <title>VMT103</title>
          <desc>VMT103</desc>
          <g id="vmt103_body_1" transform="translate(6.37795,-16.4764)" className={clsvmt103_body}>
            <path d="M0 594.53 L8.5 594.53 L8.5 586.02 L0 586.02 L0 594.53 Z" className={`${st4} ${clsvmt103_path_1_1}`} />
            <path d="M0 594.53 L8.5 594.53 L8.5 586.02 L0 586.02 L0 594.53" className={`${st5} ${clsvmt103_path_1_2}`} />
            <path d="M4.25 594.53 L4.25 600.37" className={`${st5} ${clsvmt103_path_1_3}`} />
          </g>
          <g id="vmt103_body_2" className={clsvmt103_body}>
            <path d="M0 589.21 L0 578.58 L21.26 589.21 L21.26 578.58 L0 589.21 Z" className={`${st2} ${clsvmt103_path_2_1}`} />
            <text x="546.96" y="-8.69" transform="rotate(90)" className={st3}>VMT103</text>			</g>
        </g>
        <g id="tnk101_vmt103_body" transform="translate(306.517,-243.191)" className={clstnk101_vmt103_body}>
          <path d="M-7.09 594.53 L-7.09 573.27" className={`${st5} ${clstnk101_vmt103_path_1}`} />
        </g>
        <g id="clp101_body" transform="translate(830.177,294.643) rotate(90)" className={clsclp101_body}>
          <title>CLP101</title>
          <desc>CLP101</desc>
          <path d="M0 594.53 L0 573.27 L7.09 587.44 L14.17 573.27 L14.17 594.53" className={`${st5} ${clsclp101_path_1}`} />
          <rect x="-590.743" y="-7.8518" width="17.9442" height="7.20016" transform="rotate(-90)" className={`${st16} ${clsclp101_path_2}`} />
          <text x="-590.74" y="-2.45" transform="rotate(-90)" className={st3}>CLP101</text>		</g>
        <g id="ambientair_group" transform="translate(8.87893,-289.254)" className={clsambientair_group}>
          <title>Ambient Air</title>
          <desc>AMBIENT AIR</desc>
          <g id="ambientair_body_1" transform="translate(21.2598,-10.6299)" className={clsambientair_body}>
          </g>
          <g id="ambientair_body_2" className={clsambientair_body}>
            <rect x="0" y="573.267" width="42.5197" height="21.2598" rx="10.6299" ry="10.6299" className={`${st2} ${clsambientair_path_2_1}`} />
          </g>
          <g id="ambientair_body_3" className={clsambientair_body}>
            <text x="9.71" y="582.1" className={st3}>AMBIENT  <tspan x="17.14" dy="1.2em" className={st6}>AIR</tspan></text>			</g>
        </g>
        <g id="par101_body" transform="translate(674.272,284.013) rotate(90)" className={clspar101_body}>
          <title>PAR101</title>
          <desc>PAR101</desc>
          <path d="M0 583.9 A10.6299 10.6299 0 0 1 21.26 583.9 A10.6299 10.6299 0 1 1 0 583.9 Z" className={`${st4} ${clspar101_path_1}`} />
          <path d="M0 583.9 A10.6299 10.6299 0 0 1 21.26 583.9 A10.6299 10.6299 0 1 1 0 583.9" className={`${st5} ${clspar101_path_2}`} />
          <path d="M0.97 588.33 L5.31 574.69" className={`${st5} ${clspar101_path_3}`} />
          <path d="M20.29 588.33 L15.94 574.69" className={`${st5} ${clspar101_path_4}`} />
          <path d="M10.63 590.1 L10.63 577.7" className={`${st5} ${clspar101_path_5}`} />
          <path d="M7.09 578.58 A7.52953 7.52953 0 0 1 14.17 578.58" className={`${st5} ${clspar101_path_6}`} />
          <path d="M7.09 589.21 A7.52953 7.52953 -180 0 0 14.17 589.21" className={`${st5} ${clspar101_path_7}`} />
          <path d="M10.63 599.84 L10.63 594.53" className={`${st5} ${clspar101_path_8}`} />
          <path d="M10.63 573.27 L10.63 567.95" className={`${st5} ${clspar101_path_9}`} />
          <text x="-592.66" y="27.45" transform="rotate(-90)" className={st3}>PAR101</text>		</g>
        <g id="ambientair_par101_body" transform="translate(51.3986,-292.797)" className={clsambientair_par101_body}>

          <title>Ambient Air PAR101</title>
          <path
            d="M0 587.44 L20.01 587.44"
            className={`${st7} ${clsambientair_par101_path_1}`}
            markerEnd="url(#arrow-right)"
          />
        </g>
        <g id="tnk102_body" transform="translate(228.564,-469.963)" className={clstnk102_body}>
          {/* Fill indicator */}
          <rect
            x="0"
            y={594.53 - tnk102_fill_value}
            width="77.95"
            height={tnk102_fill_value}
            fill="#4A90E2"
          />
          <title>TNK102</title>
          <path d="M0 594.53 L58.46 594.53 L64.96 612.25 L77.95 612.25 L77.95 594.53 L77.95 488.23 L38.98 488.23 L0 488.23 L0 594.53        Z" className={`${st2} ${clstnk102_path_1}`} />
          <text x="30.73" y="484.64" className={st3}>TNK102</text>		</g>
        <g id="tnk103_body" transform="translate(412.816,-427.443)" className={clstnk103_body}>
          <title>TNK103</title>
          <desc>TNK103</desc>
          <path d="M0 594.53 L42.52 594.53 L42.52 564.29 L26.57 554.84 L26.57 549.17 L15.94 549.17 L15.94 554.84 L0 564.29 L0 594.53        Z" className={`${st2} ${clstnk103_path_1}`} />
          <text x="0.4" y="599.84" className={st3}>TNK103</text>		</g>
        <g id="clp101_fuf101_body" transform="translate(235.651,-292.797)" className={clsclp101_fuf101_body}>
          <title>CLP101_FUF101</title>
          <desc>*TO MEMBRANE (FUF101) AIR INLET ON THE FEED PORT*</desc>
          <path d="M0 601.61 L-47.24 601.61" className={`${st5} ${clsclp101_fuf101_path_1}`} />
          <path d="M-51.97 601.61 L-89.11 601.61" className={`${st10} ${clsclp101_fuf101_path_2}`} />
          <rect x="-130.151" y="608.587" width="76.0509" height="14.4001" className={`${st9} ${clsclp101_fuf101_path_3}`} />
          <text x="-124.97" y="613.99" className={st11}>*TO MEMBRANE (FUF101)  <tspan x="-130.15" dy="1.2em" className={st6}>AIR INLET ON THE FEED PORT*</tspan></text>		</g>
        <g id="vnr102_group" transform="translate(334.863,-402.463)" className={clsvnr102_group}>
          <title>VNR102</title>
          <desc>VNR102</desc>
          <g id="vnr102_body_1" className={clsvnr102_body}>
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32 L0 589.12 Z" className={`${st4} ${clsvnr102_path_1_1}`} />
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32" className={`${st5} ${clsvnr102_path_1_2}`} />
            <text x="1.23" y="595.44" className={st3}>VNR102</text>			</g>
          <g id="vnr102_body_2" transform="translate(-1.08071,-15.1299)" className={clsvnr102_body}>
            <ellipse cx="1.08071" cy="593.446" rx="1.08071" ry="1.08071" className={`${st2} ${clsvnr102_path_2_1}`} />
          </g>
        </g>
        <g id="vmt117_group" transform="translate(-209.703,245.037) rotate(-90)" className={clsvmt117_group}>
          <title>VMT117</title>
          <desc>VMT117</desc>
          <g id="vmt117_body_1" transform="translate(6.48425,-16.751)" className={clsvmt117_body}>
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53 Z" className={`${st4} ${clsvmt117_path_1_1}`} />
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53" className={`${st5} ${clsvmt117_path_1_2}`} />
            <path d="M4.32 594.53 L4.32 600.47" className={`${st5} ${clsvmt117_path_1_3}`} />
          </g>
          <g id="vmt117_body_2" className={clsvmt117_body}>
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32 L0 589.12 Z" className={`${st2} ${clsvmt117_path_2_1}`} />
            <text x="586.72" y="-8.12" transform="rotate(90)" className={st3}>VMT117</text>			</g>
        </g>
        <g id="vmt118_group" transform="translate(-209.703,294.997) rotate(-90)" className={clsvmt118_group}>
          <title>VMT118</title>
          <desc>VMT118</desc>
          <g id="vmt118_body_1" transform="translate(6.48425,-16.751)" className={clsvmt118_body}>
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53 Z" className={`${st4} ${clsvmt118_path_1_1}`} />
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53" className={`${st5} ${clsvmt118_path_1_2}`} />
            <path d="M4.32 594.53 L4.32 600.47" className={`${st5} ${clsvmt118_path_1_3}`} />
          </g>
          <g id="vmt118_body_2" className={clsvmt118_body}>
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32 L0 589.12 Z" className={`${st2} ${clsvmt118_path_2_1}`} />
            <text x="587.28" y="-9.04" transform="rotate(90)" className={st3}>VMT118</text>			</g>
        </g>
        <g id="tnk102_drain_body" transform="translate(306.517,-562.372)" className={clstnk102_drain_body}>
          <title>TNK102 DRAIN</title>
          <desc>Tank Overflow</desc>
          <path d="M0 594.53 L21.26 594.53 L21.26 1032.76" className={`${st5} ${clstnk102_drain_path_1}`} />
          <rect x="-633.708" y="13.4082" width="35.2763" height="7.20016" transform="rotate(-90)" className={`${st9} ${clstnk102_drain_path_2}`} />
          <text x="-633.71" y="18.81" transform="rotate(-90)" className={st12}>Tank Overflow</text>		</g>
        <g id="tnk101_drain_body" transform="translate(306.517,-356.718)" className={clstnk101_drain_body}>
          <title>TNK101 DRAIN</title>
          <desc>Tank Overflow</desc>
          <path d="M0 594.53 L14.17 594.53 L14.17 827.11" className={`${st5} ${clstnk101_drain_path_1}`} />
          <rect x="-633.85" y="6.32156" width="35.2763" height="7.20016" transform="rotate(-90)" className={`${st9} ${clstnk101_drain_path_2}`} />
          <text x="-633.85" y="11.72" transform="rotate(-90)" className={st12}>Tank Overflow</text>		</g>
        <g id="vnr104_group" transform="translate(957.903,145.824) rotate(90)" className={clsvnr104_group}>
          <title>VNR104</title>
          <desc>VNR104</desc>
          <g id="vnr104_body_1" className={clsvnr104_body}>
            <path d="M0 589.21 L0 578.58 L21.26 589.21 L21.26 578.58 L0 589.21 Z" className={`${st4} ${clsvnr104_path_1_1}`} />
            <path d="M0 589.21 L0 578.58 L21.26 589.21 L21.26 578.58" className={`${st5} ${clsvnr104_path_1_2}`} />
            <text x="-577.43" y="11.72" transform="rotate(-90)" className={st3}>VNR104</text>			</g>
          <g id="vnr104_body_2" transform="translate(-1.06299,-14.8819)" className={clsvnr104_body}>
            <ellipse cx="1.06299" cy="593.464" rx="1.06299" ry="1.06299" className={`${st2} ${clsvnr104_path_2_1}`} />
          </g>
        </g>
        <g id="tnk103_pch101_body" transform="translate(434.076,-469.608)" className={clstnk103_pch101_body}>
          <path d="M0 591.34 L0 583.54 L-22.59 583.54" className={`${st5} ${clstnk103_pch101_path_1}`} />
        </g>
        <g id="pch101_vnr104_body" transform="translate(383.623,-480.592)" className={clspch101_vnr104_body}>
          <path d="M-4.56 594.53 L-9.62 594.53 L-9.62 626.42" className={`${st5} ${clspch101_vnr104_path_1}`} />
        </g>
        <g id="pfl101_body" transform="translate(993.169,248.403) rotate(90)" className={clspfl101_body}>
          <title>PFL101</title>
          <desc>PFL101</desc>
          <path d="M0 583.72 A10.8071 10.8071 0 1 1 21.61 583.72 A10.8071 10.8071 0 0 1 0 583.72 Z" className={`${st4} ${clspfl101_path_1}`} />
          <path d="M0 583.72 A10.8071 10.8071 0 1 1 21.61 583.72 A10.8071 10.8071 0 0 1 0 583.72" className={`${st5} ${clspfl101_path_2}`} />
          <path d="M0 583.72 L10.81 572.91 L21.61 583.72" className={`${st5} ${clspfl101_path_3}`} />
          <path d="M10.81 594.53 L10.81 572.91" className={`${st5} ${clspfl101_path_4}`} />
          <path d="M10.81 599.93 L10.81 594.53" className={`${st5} ${clspfl101_path_5}`} />
          <path d="M10.81 572.91 L10.81 567.51" className={`${st5} ${clspfl101_path_6}`} />
          <text x="-591.94" y="27.67" transform="rotate(-90)" className={st3}>PFL101</text>		</g>
        <g id="pch101_body" transform="translate(-188.443,124.564) rotate(-90)" className={clspch101_body}>
          <title>PCH101</title>
          <desc>PCH101</desc>
          <path d="M0 583.72 A10.6299 10.8071 0 1 1 21.26 583.72 A10.6299 10.8071 0 0 1 0 583.72 Z" className={`${st4} ${clspch101_path_1}`} />
          <path d="M0 583.72 A10.6299 10.8071 0 1 1 21.26 583.72 A10.6299 10.8071 0 0 1 0 583.72" className={`${st5} ${clspch101_path_2}`} />
          <path d="M0 583.72 L10.63 572.91 L21.26 583.72" className={`${st5} ${clspch101_path_3}`} />
          <path d="M10.63 599.93 L10.63 594.53" className={`${st5} ${clspch101_path_4}`} />
          <path d="M10.63 572.91 L10.63 567.51" className={`${st5} ${clspch101_path_5}`} />
          <text x="574.67" y="-23.71" transform="rotate(90)" className={st3}>PCH101</text>		</g>
        <g id="column1092_body" transform="translate(632.147,-370.75)" className={clscolumn1092_body}>
          <path d="M0 589.21 A10.8044 6.47356 -180 0 0 21.26 589.21 L21.26 487.16 A10.8044 6.47356 -180 0 0 -0 487.16 L0 589.21        Z" className={`${st13} ${clscolumn1092_path_1}`} />
        </g>
        <g id="fuf101_body" transform="translate(632.147,-377.837)" className={clsfuf101_body}>
          <title>FUF101</title>
          <desc>FUF101</desc>
          <path d="M0 594.53 L0 495.31 L21.26 495.31 L21.26 594.53 L0 594.53 Z" className={`${st14} ${clsfuf101_path_1}`} />
          <path d="M0 594.53 L0 495.31 L21.26 495.31 L21.26 594.53 L0 594.53" className={`${st5} ${clsfuf101_path_2}`} />
          <path d="M0 594.53 L3.04 580.34" className={`${st5} ${clsfuf101_path_3}`} />
          <path d="M5.23 570.12 L9.12 551.96" className={`${st5} ${clsfuf101_path_4}`} />
          <path d="M12.14 537.88 L15.18 523.69" className={`${st5} ${clsfuf101_path_5}`} />
          <path d="M18.22 509.5 L21.26 495.31" className={`${st5} ${clsfuf101_path_6}`} />
          <text x="-20.3" y="541.48" className={st3}>FUF101</text>		</g>
        <g id="fsm102_body" transform="translate(504.942,-292.797)" className={clsfsm102_body}>
          <title>FSM102</title>
          <desc>FSM102</desc>
          <path d="M0 594.53 L0 566.18 L14.17 566.18 L14.17 594.53 L0 594.53 Z" className={`${st4} ${clsfsm102_path_1}`} />
          <path d="M0 594.53 L0 566.18 L14.17 566.18 L14.17 594.53 L0 594.53" className={`${st5} ${clsfsm102_path_2}`} />
          <path d="M0 594.53 L2.03 590.47" className={`${st5} ${clsfsm102_path_3}`} />
          <path d="M3.49 587.55 L6.08 582.37" className={`${st5} ${clsfsm102_path_4}`} />
          <path d="M8.09 578.34 L10.12 574.29" className={`${st5} ${clsfsm102_path_5}`} />
          <path d="M12.15 570.23 L14.17 566.18" className={`${st5} ${clsfsm102_path_6}`} />
          <text x="-2.8" y="563.73" className={st3}>FSM102</text>		</g>
        <g id="vmt105_group" transform="translate(-71.691,372.95) rotate(-90)" className={clsvmt105_group}>
          <title>VMT105</title>
          <desc>VMT105</desc>
          <g id="vmt105_body_1" transform="translate(6.48425,-16.751)" className={clsvmt105_body}>
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53 Z" className={`${st4} ${clsvmt105_path_1_1}`} />
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53" className={`${st5} ${clsvmt105_path_1_2}`} />
            <path d="M4.32 594.53 L4.32 600.47" className={`${st5} ${clsvmt105_path_1_3}`} />
          </g>
          <g id="vmt105_body_2" className={clsvmt105_body}>
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32 L0 589.12 Z" className={`${st2} ${clsvmt105_path_2_1}`} />
            <text x="545.93" y="-8.48" transform="rotate(90)" className={st3}>VMT105</text>			</g>
        </g>
        <g id="fsm102_vmt105_body" transform="translate(504.942,-292.797)" className={clsfsm102_vmt105_body}>
          <path d="M7.09 594.53 L7.09 644.13" className={`${st5} ${clsfsm102_vmt105_path_1}`} />
        </g>
        <g id="fsm103_body" transform="translate(554.548,-292.797)" className={clsfsm103_body}>
          <title>FSM103</title>
          <desc>FSM103</desc>
          <path d="M0 594.53 L0 566.18 L14.17 566.18 L14.17 594.53 L0 594.53 Z" className={`${st4} ${clsfsm103_path_1}`} />
          <path d="M0 594.53 L0 566.18 L14.17 566.18 L14.17 594.53 L0 594.53" className={`${st5} ${clsfsm103_path_2}`} />
          <path d="M0 594.53 L2.03 590.47" className={`${st5} ${clsfsm103_path_3}`} />
          <path d="M3.49 587.55 L6.08 582.37" className={`${st5} ${clsfsm103_path_4}`} />
          <path d="M8.09 578.34 L10.12 574.29" className={`${st5} ${clsfsm103_path_5}`} />
          <path d="M12.15 570.23 L14.17 566.18" className={`${st5} ${clsfsm103_path_6}`} />
          <text x="-2.8" y="563.73" className={st3}>FSM103</text>		</g>
        <g id="vmt106_group" transform="translate(-22.0847,372.95) rotate(-90)" className={clsvmt106_group}>
          <title>VMT106</title>
          <desc>VMT106</desc>
          <g id="vmt106_body_1" transform="translate(6.48425,-16.751)" className={clsvmt106_body}>
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53 Z" className={`${st4} ${clsvmt106_path_1_1}`} />
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53" className={`${st5} ${clsvmt106_path_1_2}`} />
            <path d="M4.32 594.53 L4.32 600.47" className={`${st5} ${clsvmt106_path_1_3}`} />
          </g>
          <g id="vmt106_body_2" className={clsvmt106_body}>
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32 L0 589.12 Z" className={`${st2} ${clsvmt106_path_2_1}`} />
            <text x="586.19" y="-9.33" transform="rotate(90)" className={st3}>VMT106</text>			</g>
        </g>
        <g id="fsm103_vmt106_body" transform="translate(554.548,-292.797)" className={clsfsm103_vmt106_body}>
          <path d="M7.09 594.53 L7.09 644.13" className={`${st5} ${clsfsm103_vmt106_path_1}`} />
        </g>
        <g id="fsm103_vmt108_body" transform="translate(568.721,-299.884)" className={clsfsm103_vmt108_body}>
          <path d="M0 587.44 L14.17 587.44" className={`${st5} ${clsfsm103_vmt108_path_1}`} />
        </g>
        <g id="poweredvalve1120_group" transform="translate(582.895,-296.163)" className={clspoweredvalve1120_group}>
          <title>VMT108</title>
          <desc>VMT108</desc>
          <g id="poweredvalve1120_body_1" transform="translate(6.48425,-16.751)" className={clspoweredvalve1120_body}>
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53 Z" className={`${st4} ${clspoweredvalve1120_path_1_1}`} />
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53" className={`${st5} ${clspoweredvalve1120_path_1_2}`} />
            <path d="M4.32 594.53 L4.32 600.47" className={`${st5} ${clspoweredvalve1120_path_1_3}`} />
          </g>
          <g id="poweredvalve1120_body_2" className={clspoweredvalve1120_body}>
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32 L0 589.12 Z" className={`${st2} ${clspoweredvalve1120_path_2_1}`} />
            <text x="0.2" y="595.44" className={st3}>VMT108</text>			</g>
        </g>
        <g id="vhv104_body" transform="translate(1226.32,273.383) rotate(90) scale(-1,1)" className={clsvhv104_body}>
          <title>VHV104</title>
          <desc>VHV104</desc>
          <path d="M0 578.58 L0 589.21 L21.26 578.58 L21.26 589.21 L0 578.58 Z" className={`${st4} ${clsvhv104_path_1}`} />
          <path d="M0 578.58 L0 589.21 L21.26 578.58 L21.26 589.21 L0 578.58" className={`${st5} ${clsvhv104_path_2}`} />
          <path d="M10.63 583.9 L10.63 573.27" className={`${st5} ${clsvhv104_path_3}`} />
          <path d="M5.31 573.27 L15.94 573.27" className={`${st5} ${clsvhv104_path_4}`} />
          <text x="-571.2" y="-9.68" transform="rotate(90) scale(-1,1)" className={st3}>VHV104</text>		</g>
        <g id="vmt110_group" transform="translate(58.7027,372.95) rotate(-90)" className={clsvmt110_group}>
          <title>VMT110</title>
          <desc>VMT110</desc>
          <g id="vmt110_body_1" transform="translate(6.48425,-16.751)" className={clsvmt110_body}>
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53 Z" className={`${st4} ${clsvmt110_path_1_1}`} />
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53" className={`${st5} ${clsvmt110_path_1_2}`} />
            <path d="M4.32 594.53 L4.32 600.47" className={`${st5} ${clsvmt110_path_1_3}`} />
          </g>
          <g id="vmt110_body_2" className={clsvmt110_body}>
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32 L0 589.12 Z" className={`${st2} ${clsvmt110_path_2_1}`} />
            <text x="546.5" y="-8.48" transform="rotate(90)" className={st3}>VMT110</text>			</g>
        </g>
        <g id="vhv103_body" transform="translate(458.702,-274.903)" className={clsvhv103_body}>
          <title>VHV103</title>
          <desc>VHV103</desc>
          <path d="M0 578.32 L0 589.12 L21.61 578.32 L21.61 589.12 L0 578.32 Z" className={`${st4} ${clsvhv103_path_1}`} />
          <path d="M0 578.32 L0 589.12 L21.61 578.32 L21.61 589.12 L0 578.32" className={`${st5} ${clsvhv103_path_2}`} />
          <path d="M10.81 583.72 L10.81 572.91" className={`${st5} ${clsvhv103_path_3}`} />
          <path d="M5.4 572.91 L16.21 572.91" className={`${st5} ${clsvhv103_path_4}`} />
          <text x="0.94" y="594.59" className={st3}>VHV103</text>		</g>
        <g id="highpressureservicingwater_group" transform="translate(391.556,-275.081)" className={clshighpressureservicingwater_group}>
          <title>High Pressure Servicing Water</title>
          <desc>HIGH PRESSURE SERVICING WATER</desc>
          <g id="highpressureservicingwater_body_1" transform="translate(25.5118,-10.6299)" className={clshighpressureservicingwater_body}>
          </g>
          <g id="highpressureservicingwater_body_2" className={clshighpressureservicingwater_body}>
            <rect x="0" y="573.267" width="51.0236" height="21.2598" rx="10.6299" ry="10.6299" className={`${st2} ${clshighpressureservicingwater_path_2_1}`} />
          </g>
          <g id="highpressureservicingwater_body_3" className={clshighpressureservicingwater_body}>
            <text x="6.03" y="582.1" className={st3}>HIGH PRESSURE  <tspan x="2.76" dy="1.2em" className={st6}>SERVICING WATER</tspan></text>			</g>
        </g>
        <g id="majorpipeliner1132_body" transform="translate(442.58,-278.624)" className={clsmajorpipeliner1132_body}>
          <path d="M2.66 587.44 L3.02 587.44 L16.12 587.44" className={`${st15} ${clsmajorpipeliner1132_path_1}`} markerStart="url(#arrow-left)" />
        </g>
        <g id="vnr107_group" transform="translate(581.123,-345.77)" className={clsvnr107_group}>
          <title>VNR107</title>
          <desc>VNR107</desc>
          <g id="vnr107_body_1" className={clsvnr107_body}>
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32 L0 589.12 Z" className={`${st4} ${clsvnr107_path_1_1}`} />
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32" className={`${st5} ${clsvnr107_path_1_2}`} />
            <text x="-0.69" y="596.33" className={st3}>VNR107</text>			</g>
          <g id="vnr107_body_2" transform="translate(-1.08071,-15.1299)" className={clsvnr107_body}>
            <ellipse cx="1.08071" cy="593.446" rx="1.08071" ry="1.08071" className={`${st2} ${clsvnr107_path_2_1}`} />
          </g>
        </g>
        <g id="vnr106_group" transform="translate(788.406,-349.49) scale(-1,1)" className={clsvnr106_group}>
          <title>VNR106</title>
          <desc>VNR106</desc>
          <g id="vnr106_body_1" className={clsvnr106_body}>
            <path d="M0 589.21 L0 578.58 L21.26 589.21 L21.26 578.58 L0 589.21 Z" className={`${st4} ${clsvnr106_path_1_1}`} />
            <path d="M0 589.21 L0 578.58 L21.26 589.21 L21.26 578.58" className={`${st5} ${clsvnr106_path_1_2}`} />
            <text x="-20.6" y="595.9" transform="scale(-1,1)" className={st3}>VNR106</text>			</g>
          <g id="vnr106_body_2" transform="translate(-1.06299,-14.8819)" className={clsvnr106_body}>
            <ellipse cx="1.06299" cy="593.464" rx="1.06299" ry="1.06299" className={`${st2} ${clsvnr106_path_2_1}`} />
          </g>
        </g>
        <g id="air_par101_body" transform="translate(500.69,-349.49)" className={clsair_par101_body}>
          <title>Air-PAR101</title>
          <desc>*FROM AIR PUMP PAR101*</desc>
          <path d="M0 587.44 L77.41 587.44" className={`${st7} ${clsair_par101_path_1}`} markerEnd="url(#arrow-right)" />
          <rect x="-0.468855" y="578.171" width="68.9694" height="7.20016" className={`${st9} ${clsair_par101_path_2}`} />
          <text x="-0.47" y="583.57" className={st11}>*FROM AIR PUMP PAR101*</text>		</g>
        <g id="par102_body" transform="translate(236.399,245.037) rotate(-90)" className={clspar102_body}>
          <title>PAR102</title>
          <desc>PAR102</desc>
          <path d="M0 583.9 A10.6299 10.6299 0 0 1 21.26 583.9 A10.6299 10.6299 0 1 1 0 583.9 Z" className={`${st14} ${clspar102_path_1}`} />
          <path d="M0 583.9 A10.6299 10.6299 0 0 1 21.26 583.9 A10.6299 10.6299 0 1 1 0 583.9" className={`${st5} ${clspar102_path_2}`} />
          <path d="M0 583.9 L10.63 573.27 L21.26 583.9" className={`${st5} ${clspar102_path_3}`} />
          <path d="M0 583.9 A13.2874 13.2874 -180 0 0 21.26 583.9" className={`${st5} ${clspar102_path_4}`} />
          <path d="M10.63 599.84 L10.63 594.53" className={`${st5} ${clspar102_path_5}`} />
          <path d="M10.63 573.27 L10.63 567.95" className={`${st5} ${clspar102_path_6}`} />
          <text x="574.56" y="6.19" transform="rotate(90)" className={st3}>PAR102</text>		</g>
        <g id="ambientair2_group" transform="translate(857.855,-349.49)" className={clsambientair2_group}>
          <title>Ambient Air 2</title>
          <desc>AMBIENT AIR</desc>
          <g id="ambientair2_body_1" transform="translate(21.2598,-10.6299)" className={clsambientair2_body}>
          </g>
          <g id="ambientair2_body_2" className={clsambientair2_body}>
            <rect x="0" y="573.267" width="42.5197" height="21.2598" rx="10.6299" ry="10.6299" className={`${st2} ${clsambientair2_path_2_1}`} />
          </g>
          <g id="ambientair2_body_3" className={clsambientair2_body}>
            <text x="4.91" y="585.7" className={st3}>AMBIENT AIR</text>			</g>
        </g>
        <g id="air_par102_body" transform="translate(857.855,-353.033)" className={clsair_par102_body}>
          <title>AIR-PAR102</title>
          <path d="M0 587.44 L-18.59 587.44" className={`${st7} ${clsair_par102_path_1}`} markerEnd="url(#arrow-right)" />
        </g>
        <g id="par102_vnr106_body" transform="translate(788.406,-353.033)" className={clspar102_vnr106_body}>
          <path d="M0 587.44 L15.94 587.44" className={`${st5} ${clspar102_vnr106_path_1}`} />
        </g>
        <g id="shape1147-313" transform="translate(619.745,-360.68)">
          <desc>Feed</desc>
          <rect x="0" y="585.724" width="25.5118" height="8.80232" className={st16} />
          <text x="9.94" y="591.93" className={st12}>Feed</text>		</g>
        <g id="shape1148-316" transform="translate(606.939,-482.42)">
          <desc>Concentrate</desc>
          <rect x="0" y="585.724" width="42.5197" height="8.80232" className={st16} />
          <text x="4" y="591.93" className={st12}>Concentrate</text>		</g>
        <g id="vmt107_group" transform="translate(102.108,372.95) rotate(-90)" className={clsvmt107_group}>
          <title>VMT107</title>
          <desc>VMT107</desc>
          <g id="vmt107_body_1" transform="translate(6.48425,-16.751)" className={clsvmt107_body}>
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53 Z" className={`${st4} ${clsvmt107_path_1_1}`} />
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53" className={`${st5} ${clsvmt107_path_1_2}`} />
            <path d="M4.32 594.53 L4.32 600.47" className={`${st5} ${clsvmt107_path_1_3}`} />
          </g>
          <g id="vmt107_body_2" className={clsvmt107_body}>
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32 L0 589.12 Z" className={`${st2} ${clsvmt107_path_2_1}`} />
            <text x="547.03" y="-9.18" transform="rotate(90)" className={st3}>VMT107</text>			</g>
        </g>
        <g id="fuf101_vmt107_body" transform="translate(642.777,-483.427)" className={clsfuf101_vmt107_body}>
          <path d="M0 594.53 L0 573.98 L43.05 573.98 L43.05 834.76" className={`${st5} ${clsfuf101_all_lines}`} />
        </g>
        <g id="vmt112_group" transform="translate(781.32,-459.155)" className={clsvmt112_group}>
          <title>VMT112</title>
          <desc>VMT112</desc>
          <g id="vmt112_body_1" transform="translate(6.48425,-16.751)" className={clsvmt112_body}>
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53 Z" className={`${st4} ${clsvmt112_path_1_1}`} />
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53" className={`${st5} ${clsvmt112_path_1_2}`} />
            <path d="M4.32 594.53 L4.32 600.47" className={`${st5} ${clsvmt112_path_1_3}`} />
          </g>
          <g id="vmt112_body_2" className={clsvmt112_body}>
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32 L0 589.12 Z" className={`${st2} ${clsvmt112_path_2_1}`} />
            <text x="1.05" y="596.01" className={st3}>VMT112</text>			</g>
        </g>
        <g id="vmt111_group" transform="translate(169.254,372.95) rotate(-90)" className={clsvmt111_group}>
          <title>VMT111</title>
          <desc>VMT111</desc>
          <g id="vmt111_body_1" transform="translate(6.48425,-16.751)" className={clsvmt111_body}>
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53 Z" className={`${st4} ${clsvmt111_path_1_1}`} />
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53" className={`${st5} ${clsvmt111_path_1_2}`} />
            <path d="M4.32 594.53 L4.32 600.47" className={`${st5} ${clsvmt111_path_1_3}`} />
          </g>
          <g id="vmt111_body_2" className={clsvmt111_body}>
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32 L0 589.12 Z" className={`${st2} ${clsvmt111_path_2_1}`} />
            <text x="587.6" y="-9.04" transform="rotate(90)" className={st3}>VMT111</text>			</g>
        </g>
        <g id="shape1163-346" transform="translate(652.343,-468.396)">
          <desc>Filtrate</desc>
          <rect x="0" y="585.724" width="42.5197" height="8.80232" className={st16} />
          <text x="4" y="591.93" className={st12}>Filtrate</text>		</g>
        <g id="vmt109_group" transform="translate(1350.87,82.0444) rotate(90)" className={clsvmt109_group}>
          <title>VMT109</title>
          <desc>VMT109</desc>
          <g id="vmt109_body_1" transform="translate(6.48425,-16.751)" className={clsvmt109_body}>
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53 Z" className={`${st4} ${clsvmt109_path_1_1}`} />
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53" className={`${st5} ${clsvmt109_path_1_2}`} />
            <path d="M4.32 594.53 L4.32 600.47" className={`${st5} ${clsvmt109_path_1_3}`} />
          </g>
          <g id="vmt109_body_2" className={clsvmt109_body}>
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32 L0 589.12 Z" className={`${st2} ${clsvmt109_path_2_1}`} />
            <text x="-567.79" y="13.14" transform="rotate(-90)" className={st3}>VMT109</text>			</g>
        </g>
        <g id="fcb101_body" transform="translate(838.013,-455.789)" className={clsfcb101_body}>
          <title>FCB101</title>
          <desc>FCB101</desc>
          <path d="M0 594.53 L0 566.18 L14.17 566.18 L14.17 594.53 L0 594.53 Z" className={`${st4} ${clsfcb101_path_1}`} />
          <path d="M0 594.53 L0 566.18 L14.17 566.18 L14.17 594.53 L0 594.53" className={`${st5} ${clsfcb101_path_2}`} />
          <path d="M0 594.53 L2.03 590.47" className={`${st5} ${clsfcb101_path_3}`} />
          <path d="M3.49 587.55 L6.08 582.37" className={`${st5} ${clsfcb101_path_4}`} />
          <path d="M8.09 578.34 L10.12 574.29" className={`${st5} ${clsfcb101_path_5}`} />
          <path d="M12.15 570.23 L14.17 566.18" className={`${st5} ${clsfcb101_path_6}`} />
          <text x="-2.08" y="564.3" className={st3}>FCB101</text>		</g>
        <g id="vmt113_group" transform="translate(318.073,103.659) rotate(-90)" className={clsvmt113_group}>
          <title>VMT113</title>
          <desc>VMT113</desc>
          <g id="vmt113_body_1" transform="translate(6.48425,-16.751)" className={clsvmt113_body}>
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53 Z" className={`${st4} ${clsvmt113_path_1_1}`} />
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53" className={`${st5} ${clsvmt113_path_1_2}`} />
            <path d="M4.32 594.53 L4.32 600.47" className={`${st5} ${clsvmt113_path_1_3}`} />
          </g>
          <g id="vmt113_body_2" className={clsvmt113_body}>
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32 L0 589.12 Z" className={`${st2} ${clsvmt113_path_2_1}`} />
            <text x="547.35" y="-9.33" transform="rotate(90)" className={st3}>VMT113</text>			</g>
        </g>
        <g id="vnr108_group" transform="translate(866.359,-459.155)" className={clsvnr108_group}>
          <title>VNR108</title>
          <desc>VNR108</desc>
          <g id="vnr108_body_1" className={clsvnr108_body}>
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32 L0 589.12 Z" className={`${st4} ${clsvnr108_path_1_1}`} />
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32" className={`${st5} ${clsvnr108_path_1_2}`} />
            <text x="1.51" y="596.01" className={st3}>VNR108</text>			</g>
          <g id="vnr108_body_2" transform="translate(-1.08071,-15.1299)" className={clsvnr108_body}>
            <ellipse cx="1.08071" cy="593.446" rx="1.08071" ry="1.08071" className={`${st2} ${clsvnr108_path_2_1}`} />
          </g>
        </g>
        <g id="fcb101_vnr108_body" transform="translate(852.186,-462.876)" className={clsfcb101_vnr108_body}>
          <path d="M0 587.44 L14.17 587.44" className={`${st5} ${clsfcb101_vnr108_path_1}`} />
        </g>
        <g id="uvm101_body" transform="translate(923.052,-413.27)" className={clsuvm101_body}>
          <title>UVM101</title>
          <desc>UVM101</desc>
          <path d="M-0 590.98 A7.20291 4.31571 -180 0 0 14.17 590.98 L14.17 505.94 A7.20291 4.31571 -180 0 0 0 505.94 L0 590.98        Z" className={`${st13} ${clsuvm101_path_1}`} />
          <text x="-3.67" y="602" className={st3}>UVM101</text>		</g>
        <g id="vmt115_group" transform="translate(1549.47,372.596) rotate(90) scale(-1,1)" className={clsvmt115_group}>
          <title>VMT115</title>
          <desc>VMT115</desc>
          <g id="vmt115_body_1" transform="translate(6.37795,-16.4764)" className={clsvmt115_body}>
            <path d="M0 594.53 L8.5 594.53 L8.5 586.02 L0 586.02 L0 594.53 Z" className={`${st4} ${clsvmt115_path_1_1}`} />
            <path d="M0 594.53 L8.5 594.53 L8.5 586.02 L0 586.02 L0 594.53" className={`${st5} ${clsvmt115_path_1_2}`} />
            <path d="M4.25 594.53 L4.25 600.37" className={`${st5} ${clsvmt115_path_1_3}`} />
          </g>
          <g id="vmt115_body_2" className={clsvmt115_body}>
            <path d="M0 589.21 L0 578.58 L21.26 589.21 L21.26 578.58 L0 589.21 Z" className={`${st2} ${clsvmt115_path_2_1}`} />
            <text x="-609.07" y="-8.12" transform="rotate(90) scale(-1,1)" className={st3}>VMT115</text>			</g>
        </g>
        <g id="vnr105_group" transform="translate(1043.17,-473.329)" className={clsvnr105_group}>
          <title>VNR105</title>
          <desc>VNR105</desc>
          <g id="vnr105_body_1" className={clsvnr105_body}>
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32 L0 589.12 Z" className={`${st4} ${clsvnr105_path_1_1}`} />
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32" className={`${st5} ${clsvnr105_path_1_2}`} />
            <text x="-0.69" y="596.33" className={st3}>VNR105</text>			</g>
          <g id="vnr105_body_2" transform="translate(-1.08071,-15.1299)" className={clsvnr105_body}>
            <ellipse cx="1.08071" cy="593.446" rx="1.08071" ry="1.08071" className={`${st2} ${clsvnr105_path_2_1}`} />
          </g>
        </g>
        <g id="vmt116_group" transform="translate(1000.65,-473.329)" className={clsvmt116_group}>
          <title>VMT116</title>
          <desc>VMT116</desc>
          <g id="vmt116_body_1" transform="translate(6.48425,-16.751)" className={clsvmt116_body}>
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53 Z" className={`${st4} ${clsvmt116_path_1_1}`} />
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53" className={`${st5} ${clsvmt116_path_1_2}`} />
            <path d="M4.32 594.53 L4.32 600.47" className={`${st5} ${clsvmt116_path_1_3}`} />
          </g>
          <g id="vmt116_body_2" className={clsvmt116_body}>
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32 L0 589.12 Z" className={`${st2} ${clsvmt116_path_2_1}`} />
            <text x="0.69" y="595.44" className={st3}>VMT116</text>			</g>
        </g>
        <g id="vhv102_body" transform="translate(1043.52,-392.01)" className={clsvhv102_body}>
          <title>VHV102</title>
          <desc>VHV102</desc>
          <path d="M0 578.32 L0 589.12 L21.61 578.32 L21.61 589.12 L0 578.32 Z" className={`${st4} ${clsvhv102_path_1}`} />
          <path d="M0 578.32 L0 589.12 L21.61 578.32 L21.61 589.12 L0 578.32" className={`${st5} ${clsvhv102_path_2}`} />
          <path d="M10.81 583.72 L10.81 572.91" className={`${st5} ${clsvhv102_path_3}`} />
          <path d="M5.4 572.91 L16.21 572.91" className={`${st5} ${clsvhv102_path_4}`} />
          <text x="2.92" y="596.33" className={st3}>VHV102</text>		</g>
        <g id="samplewater2_group" transform="translate(1078.96,-392.187)" className={clssamplewater2_group}>
          <title>Sample Water 2</title>
          <desc>SAMPLE WATER</desc>
          <g id="samplewater2_body_1" transform="translate(21.2598,-10.6299)" className={clssamplewater2_body}>
          </g>
          <g id="samplewater2_body_2" className={clssamplewater2_body}>
            <rect x="0" y="573.267" width="42.5197" height="21.2598" rx="10.6299" ry="10.6299" className={`${st2} ${clssamplewater2_path_2_1}`} />
          </g>
          <g id="samplewater2_body_3" className={clssamplewater2_body}>
            <text x="11.3" y="582.1" className={st3}>SAMPLE  <tspan x="12.3" dy="1.2em" className={st6}>WATER</tspan></text>			</g>
        </g>
        <g id="vhv102_sample_body" transform="translate(1064.96,-395.73)" className={clsvhv102_sample_body}>
          <path d="M0.18 587.44 L10.98 587.44" className={`${st7} ${clsvhv102_sample_path_1}`} markerEnd="url(#arrow-right)" />
        </g>
        <g id="outputwater_group" transform="translate(1078.96,-473.506)" className={clsoutputwater_group}>
          <title>Output Water</title>
          <desc>OUTPUT WATER</desc>
          <g id="outputwater_body_1" transform="translate(21.2598,-10.6299)" className={clsoutputwater_body}>
          </g>
          <g id="outputwater_body_2" className={clsoutputwater_body}>
            <rect x="0" y="573.267" width="42.5197" height="21.2598" rx="10.6299" ry="10.6299" className={`${st2} ${clsoutputwater_path_2_1}`} />
          </g>
          <g id="outputwater_body_3" className={clsoutputwater_body}>
            <text x="10.95" y="582.1" className={st3}>OUTPUT  <tspan x="12.3" dy="1.2em" className={st6}>WATER</tspan></text>			</g>
        </g>
        <g id="vnr105_output_body" transform="translate(1064.78,-477.049)" className={clsvnr105_output_body}>
          <title>VNR105-Output</title>
          <path d="M0 587.44 L11.15 587.44" className={`${st7} ${clsvnr105_output_path_1}`} markerEnd="url(#arrow-right)" />
        </g>
        <g id="majorpipeline1215_body" transform="translate(1043.17,-477.049)" className={clsmajorpipeline1215_body}>
          <title>Major Pipeline.1215</title>
          <path d="M0 587.44 L-20.91 587.44" className={`${st5} ${clsmajorpipeline1215_path_1}`} />
        </g>
        <g id="vmt114_group" transform="translate(1563.46,67.8712) rotate(90)" className={clsvmt114_group}>
          <title>VMT114</title>
          <desc>VMT114</desc>
          <g id="vmt114_body_1" transform="translate(6.48425,-16.751)" className={clsvmt114_body}>
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53 Z" className={`${st4} ${clsvmt114_path_1_1}`} />
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53" className={`${st5} ${clsvmt114_path_1_2}`} />
            <path d="M4.32 594.53 L4.32 600.47" className={`${st5} ${clsvmt114_path_1_3}`} />
          </g>
          <g id="vmt114_body_2" className={clsvmt114_body}>
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32 L0 589.12 Z" className={`${st2} ${clsvmt114_path_2_1}`} />
            <text x="-567.12" y="13.14" transform="rotate(-90)" className={st3}>VMT114</text>			</g>
        </g>
        <g id="vmt114_tnk102_body" transform="translate(306.517,-569.742)" className={clsvmt114_tnk102_body}>
          <title>VMT114-TNK102</title>
          <path d="M0 594.53 L673.23 594.53 L673.23 637.61" className={`${st5} ${clsvmt114_tnk102_path_1}`} />
        </g>
        <g id="vnr103_group" transform="translate(979.745,-168.604)" className={clsvnr103_group}>
          <title>VNR103</title>
          <desc>VNR103</desc>
          <g id="vnr103_body_1" className={clsvnr103_body}>
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32 L0 589.12 Z" className={`${st4} ${clsvnr103_path_1_1}`} />
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32" className={`${st5} ${clsvnr103_path_1_2}`} />
            <text x="0.09" y="595.97" className={st3}>VNR103</text>			</g>
          <g id="vnr103_body_2" transform="translate(-1.08071,-15.1299)" className={clsvnr103_body}>
            <ellipse cx="1.08071" cy="593.446" rx="1.08071" ry="1.08071" className={`${st2} ${clsvnr103_path_2_1}`} />
          </g>
        </g>
        <g id="vnr101_group" transform="translate(979.745,-133.348)" className={clsvnr101_group}>
          <title>VNR101</title>
          <desc>VNR101</desc>
          <g id="vnr101_body_1" className={clsvnr101_body}>
            <path d="M0 589.21 L0 578.58 L21.26 589.21 L21.26 578.58 L0 589.21 Z" className={`${st4} ${clsvnr101_path_1_1}`} />
            <path d="M0 589.21 L0 578.58 L21.26 589.21 L21.26 578.58" className={`${st5} ${clsvnr101_path_1_2}`} />
            <text x="0.09" y="596.33" className={st3}>VNR101</text>			</g>
          <g id="vnr101_body_2" transform="translate(-1.06299,-14.8819)" className={clsvnr101_body}>
            <ellipse cx="1.06299" cy="593.464" rx="1.06299" ry="1.06299" className={`${st2} ${clsvnr101_path_2_1}`} />
          </g>
        </g>
        <g id="drainwater_group" transform="translate(1078.96,-131.222)" className={clsdrainwater_group}>
          <title>Drain Water</title>
          <desc>DRAIN WATER</desc>
          <g id="drainwater_body_1" transform="translate(21.2598,-12.7559)" className={clsdrainwater_body}>
          </g>
          <g id="drainwater_body_2" className={clsdrainwater_body}>
            <rect x="0" y="569.015" width="42.5197" height="25.5118" rx="12.7559" ry="12.7559" className={`${st2} ${clsdrainwater_path_2_1}`} />
          </g>
          <g id="drainwater_body_3" className={clsdrainwater_body}>
            <text x="13.36" y="579.97" className={st3}>DRAIN  <tspan x="12.3" dy="1.2em" className={st6}>WATER</tspan></text>			</g>
        </g>
        <g id="enclosuresump_body" transform="translate(-259.309,478.895) rotate(-90)" className={clsenclosuresump_body}>
          <title>Enclosure Sump</title>
          <desc>ENCLOSURE SUMP</desc>
          <path d="M14.17 594.53 L0 583.72 L14.17 572.91" className={`${st5} ${clsenclosuresump_path_1}`} />
          <text x="594.32" y="-4.44" transform="rotate(90)" className={st3}>ENCLOSURE SUMP</text>		</g>
        <g id="var102_body" transform="translate(264.746,379.682) rotate(-90)" className={clsvar102_body}>
          <title>VAR102</title>
          <desc>VAR102</desc>
          <path d="M0 590.98 L0 583.9 L10.63 580.35 L14.17 580.35 L14.17 594.53 L10.63 594.53 L0 590.98 Z" className={`${st4} ${clsvar102_path_1}`} />
          <path d="M0 590.98 L0 583.9 L10.63 580.35 L14.17 580.35 L14.17 594.53 L10.63 594.53 L0 590.98" className={`${st5} ${clsvar102_path_2}`} />
          <path d="M10.63 594.53 L10.63 580.35" className={`${st5} ${clsvar102_path_3}`} />
          <text x="597.04" y="-6.7" transform="rotate(90)" className={st3}>VAR102</text>		</g>
        <g id="var101_body" transform="translate(236.399,379.682) rotate(-90)" className={clsvar101_body}>
          <title>VAR101</title>
          <desc>VAR101</desc>
          <path d="M0 590.98 L0 583.9 L10.63 580.35 L14.17 580.35 L14.17 594.53 L10.63 594.53 L0 590.98 Z" className={`${st4} ${clsvar101_path_1}`} />
          <path d="M0 590.98 L0 583.9 L10.63 580.35 L14.17 580.35 L14.17 594.53 L10.63 594.53 L0 590.98" className={`${st5} ${clsvar101_path_2}`} />
          <path d="M10.63 594.53 L10.63 580.35" className={`${st5} ${clsvar101_path_3}`} />
          <text x="559.39" y="-6.42" transform="rotate(90)" className={st3}>VAR101</text>		</g>
        <g id="enclosuresump2_group" transform="translate(1078.96,-88.7027)" className={clsenclosuresump2_group}>
          <title>Enclosure Sump 2</title>
          <desc>ENCLOSURE SUMP</desc>
          <g id="enclosuresump2_body_1" transform="translate(22.0416,-12.7559)" className={clsenclosuresump2_body}>
          </g>
          <g id="enclosuresump2_body_2" className={clsenclosuresump2_body}>
            <rect x="0" y="569.015" width="44.0831" height="25.5118" rx="12.7559" ry="12.7559" className={`${st2} ${clsenclosuresump2_path_2_1}`} />
          </g>
          <g id="enclosuresump2_body_3" className={clsenclosuresump2_body}>
            <text x="7.4" y="579.97" className={st3}>ENCLOSURE  <tspan x="14.62" dy="1.2em" className={st6}>SUMP</tspan></text>			</g>
        </g>
        <g id="spt101_group" transform="translate(79.7451,-373.585)" className={clsspt101_group}>
          <title>SPT101</title>
          <g id="spt101_body_1" transform="translate(0.354335,0)" className={clsspt101_body}>

            <desc>101</desc>
            <g id="shape1347-497">
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53 Z" className={st14} />
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
            </g>
            <g id="shape1348-502" transform="translate(4.62992,-12.3431)">
            </g>
            <g id="shape1346-503">
              <text x="6.07" y="591.01" className={st3}>101</text>				</g>
          </g>
          <g id="spt101_body_2" transform="translate(-7.99361E-15,-10.6299)" className={clsspt101_body}>
            <desc>SPT</desc>
            <rect x="0" y="586.731" width="21.2598" height="7.79525" className={`${st16} ${clsspt101_path_2_1}`} />
            <text x="6.24" y="592.43" className={st3}>SPT</text>			</g>
        </g>
        <g id="stu101_group" transform="translate(121.91,-373.585)" className={clsstu101_group}>
          <title>STU101</title>
          <g id="stu101_body_1" transform="translate(0.354335,0)" className={clsstu101_body}>

            <desc>101</desc>
            <g id="shape1382-510">
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53 Z" className={st14} />
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
            </g>
            <g id="shape1383-515" transform="translate(4.62992,-12.3431)">
            </g>
            <g id="shape1381-516">
              <text x="6.07" y="591.01" className={st3}>101</text>				</g>
          </g>
          <g id="stu101_body_2" transform="translate(-7.99361E-15,-10.6299)" className={clsstu101_body}>
            <desc>STU</desc>
            <rect x="0" y="586.731" width="21.2598" height="7.79525" className={`${st16} ${clsstu101_path_2_1}`} />
            <text x="5.87" y="592.43" className={st3}>STU</text>			</g>
        </g>
        <g id="sct101_group" transform="translate(146.891,-373.585)" className={clssct101_group}>
          <title>SCT101</title>
          <g id="sct101_body_1" transform="translate(0.354335,0)" className={clssct101_body}>

            <desc>101</desc>
            <g id="shape1387-523">
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53 Z" className={st14} />
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
            </g>
            <g id="shape1388-528" transform="translate(4.62992,-12.3431)">
            </g>
            <g id="shape1386-529">
              <text x="6.07" y="591.01" className={st3}>101</text>				</g>
          </g>
          <g id="sct101_body_2" transform="translate(-7.99361E-15,-10.6299)" className={clssct101_body}>
            <desc>SCT</desc>
            <rect x="0" y="586.731" width="21.2598" height="7.79525" className={`${st16} ${clssct101_path_2_1}`} />
            <text x="6.19" y="592.43" className={st3}>SCT</text>			</g>
        </g>
        <g id="spt105_group" transform="translate(203.584,-373.585)" className={clsspt105_group}>
          <title>SPT105</title>
          <g id="spt105_body_1" transform="translate(0.354335,0)" className={clsspt105_body}>

            <desc>105</desc>
            <g id="shape1394-536">
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53 Z" className={st14} />
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
            </g>
            <g id="shape1395-541" transform="translate(4.62992,-12.3431)">
            </g>
            <g id="shape1393-542">
              <text x="6.07" y="591.01" className={st3}>105</text>				</g>
          </g>
          <g id="spt105_body_2" transform="translate(-7.99361E-15,-10.6299)" className={clsspt105_body}>
            <desc>SPT</desc>
            <rect x="0" y="586.731" width="21.2598" height="7.79525" className={`${st16} ${clsspt105_path_2_1}`} />
            <text x="6.24" y="592.43" className={st3}>SPT</text>			</g>
        </g>
        <g id="spt112_group" transform="translate(203.584,-316.892)" className={clsspt112_group}>
          <title>SPT112</title>
          <g id="spt112_body_1" transform="translate(0.354335,0)" className={clsspt112_body}>

            <desc>112</desc>
            <g id="shape1400-549">
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53 Z" className={st14} />
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
            </g>
            <g id="shape1401-554" transform="translate(4.62992,-12.3431)">
            </g>
            <g id="shape1399-555">
              <text x="6.07" y="591.01" className={st3}>112</text>				</g>
          </g>
          <g id="spt112_body_2" transform="translate(-7.99361E-15,-10.6299)" className={clsspt112_body}>
            <desc>SPT</desc>
            <rect x="0" y="586.731" width="21.2598" height="7.79525" className={`${st16} ${clsspt112_path_2_1}`} />
            <text x="6.24" y="592.43" className={st3}>SPT</text>			</g>
        </g>
        <g id="spt106_group" transform="translate(331.143,-494.057)" className={clsspt106_group}>
          <title>SPT106</title>
          <g id="spt106_body_1" transform="translate(0.354335,0)" className={clsspt106_body}>

            <desc>106</desc>
            <g id="shape1406-562">
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53 Z" className={st14} />
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
            </g>
            <g id="shape1407-567" transform="translate(4.62992,-12.3431)">
            </g>
            <g id="shape1405-568">
              <text x="6.07" y="591.01" className={st3}>106</text>				</g>
          </g>
          <g id="spt106_body_2" transform="translate(-7.99361E-15,-10.6299)" className={clsspt106_body}>
            <desc>SPT</desc>
            <rect x="0" y="586.731" width="21.2598" height="7.79525" className={`${st16} ${clsspt106_path_2_1}`} />
            <text x="6.24" y="592.43" className={st3}>SPT</text>			</g>
        </g>
        <g id="spt103_group" transform="translate(331.143,-302.718)" className={clsspt103_group}>
          <title>SPT103</title>
          <g id="spt103_body_1" transform="translate(0.354335,0)" className={clsspt103_body}>

            <desc>103</desc>
            <g id="shape1412-575">
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53 Z" className={st14} />
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
            </g>
            <g id="shape1413-580" transform="translate(4.62992,-12.3431)">
            </g>
            <g id="shape1411-581">
              <text x="6.07" y="591.01" className={st3}>103</text>				</g>
          </g>
          <g id="spt103_body_2" transform="translate(-7.99361E-15,-10.6299)" className={clsspt103_body}>
            <desc>SPT</desc>
            <rect x="0" y="586.731" width="21.2598" height="7.79525" className={`${st16} ${clsspt103_path_2_1}`} />
            <text x="6.24" y="592.43" className={st3}>SPT</text>			</g>
        </g>
        <g id="spt102_group" transform="translate(423.517,-352.325)" className={clsspt102_group}>
          <title>SPT102</title>
          <g id="spt102_body_1" transform="translate(0.177168,1.13687E-13)" className={clsspt102_body}>

            <desc>102</desc>
            <g id="shape1418-588">
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53 Z" className={st14} />
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
            </g>
            <g id="shape1419-593" transform="translate(4.62992,-12.3431)">
            </g>
            <g id="shape1417-594">
              <text x="6.07" y="591.01" className={st3}>102</text>				</g>
          </g>
          <g id="spt102_body_2" transform="translate(-7.99361E-15,-10.6299)" className={clsspt102_body}>
            <desc>SPT</desc>
            <rect x="0" y="586.731" width="21.2598" height="7.79525" className={`${st16} ${clsspt102_path_2_1}`} />
            <text x="6.24" y="592.43" className={st3}>SPT</text>			</g>
        </g>
        <g id="sft101_group" transform="translate(451.615,-352.325)" className={clssft101_group}>
          <title>SFT101</title>
          <g id="sft101_body_1" transform="translate(0.354335,0)" className={clssft101_body}>

            <desc>101</desc>
            <g id="shape1424-601">
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53 Z" className={st14} />
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
            </g>
            <g id="shape1425-606" transform="translate(4.62992,-12.3431)">
            </g>
            <g id="shape1423-607">
              <text x="6.07" y="591.01" className={st3}>101</text>				</g>
          </g>
          <g id="sft101_body_2" transform="translate(-7.99361E-15,-10.6299)" className={clssft101_body}>
            <desc>SFT</desc>
            <rect x="0" y="586.731" width="21.2598" height="7.79525" className={`${st16} ${clssft101_path_2_1}`} />
            <text x="6.41" y="592.43" className={st3}>SFT</text>			</g>
        </g>
        <g id="spt104_group" transform="translate(526.131,-324.262)" className={clsspt104_group}>
          <title>SPT104</title>
          <g id="spt104_body_1" transform="translate(0.177168,1.13687E-13)" className={clsspt104_body}>

            <desc>104</desc>
            <g id="shape1430-614">
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53 Z" className={st14} />
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
            </g>
            <g id="shape1431-619" transform="translate(4.62992,-12.3431)">
            </g>
            <g id="shape1429-620">
              <text x="6.07" y="591.01" className={st3}>104</text>				</g>
          </g>
          <g id="spt104_body_2" transform="translate(-7.99361E-15,-10.6299)" className={clsspt104_body}>
            <desc>SPT</desc>
            <rect x="0" y="586.731" width="21.2598" height="7.79525" className={`${st16} ${clsspt104_path_2_1}`} />
            <text x="6.24" y="592.43" className={st3}>SPT</text>			</g>
        </g>
        <g id="spt107_group" transform="translate(607.769,-324.262)" className={clsspt107_group}>
          <title>SPT107</title>
          <g id="spt107_body_1" transform="translate(0.177168,1.13687E-13)" className={clsspt107_body}>

            <desc>107</desc>
            <g id="shape1436-627">
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53 Z" className={st14} />
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
            </g>
            <g id="shape1437-632" transform="translate(4.62992,-12.3431)">
            </g>
            <g id="shape1435-633">
              <text x="6.07" y="591.01" className={st3}>107</text>				</g>
          </g>
          <g id="spt107_body_2" transform="translate(-7.99361E-15,-10.6299)" className={clsspt107_body}>
            <desc>SPT</desc>
            <rect x="0" y="586.731" width="21.2598" height="7.79525" className={`${st16} ${clsspt107_path_2_1}`} />
            <text x="6.24" y="592.43" className={st3}>SPT</text>			</g>
        </g>
        <g id="sct102_group" transform="translate(731.714,-487.679)" className={clssct102_group}>
          <title>SCT102</title>
          <g id="sct102_body_1" transform="translate(0.177168,1.13687E-13)" className={clssct102_body}>

            <desc>102</desc>
            <g id="shape1442-640">
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53 Z" className={st14} />
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
            </g>
            <g id="shape1443-645" transform="translate(4.62992,-12.3431)">
            </g>
            <g id="shape1441-646">
              <text x="6.07" y="591.01" className={st3}>102</text>				</g>
          </g>
          <g id="sct102_body_2" transform="translate(-7.99361E-15,-10.6299)" className={clssct102_body}>
            <desc>SCT</desc>
            <rect x="0" y="586.731" width="21.2598" height="7.79525" className={`${st16} ${clssct102_path_2_1}`} />
            <text x="6.19" y="592.43" className={st3}>SCT</text>			</g>
        </g>
        <g id="spt110_group" transform="translate(699.647,-486.97)" className={clsspt110_group}>
          <title>SPT110</title>
          <g id="spt110_body_1" transform="translate(0.354335,0)" className={clsspt110_body}>

            <desc>110</desc>
            <g id="shape1448-653">
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53 Z" className={st14} />
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
            </g>
            <g id="shape1449-658" transform="translate(4.62992,-12.3431)">
            </g>
            <g id="shape1447-659">
              <text x="6.07" y="591.01" className={st3}>110</text>				</g>
          </g>
          <g id="spt110_body_2" transform="translate(-7.99361E-15,-10.6299)" className={clsspt110_body}>
            <desc>SPT</desc>
            <rect x="0" y="586.731" width="21.2598" height="7.79525" className={`${st16} ${clsspt110_path_2_1}`} />
            <text x="6.24" y="592.43" className={st3}>SPT</text>			</g>
        </g>
        <g id="stu102_group" transform="translate(805.946,-486.97)" className={clsstu102_group}>
          <title>STU102</title>
          <g id="stu102_body_1" transform="translate(0.354335,0)" className={clsstu102_body}>

            <desc>102</desc>
            <g id="shape1460-666">
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53 Z" className={st14} />
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
            </g>
            <g id="shape1461-671" transform="translate(4.62992,-12.3431)">
            </g>
            <g id="shape1459-672">
              <text x="6.07" y="591.01" className={st3}>102</text>				</g>
          </g>
          <g id="stu102_body_2" transform="translate(-7.99361E-15,-10.6299)" className={clsstu102_body}>
            <desc>STU</desc>
            <rect x="0" y="586.731" width="21.2598" height="7.79525" className={`${st16} ${clsstu102_path_2_1}`} />
            <text x="5.87" y="592.43" className={st3}>STU</text>			</g>
        </g>
        <g id="spt111_group" transform="translate(940.592,-501.144)" className={clsspt111_group}>
          <title>SPT111</title>
          <g id="spt111_body_1" transform="translate(0.354335,0)" className={clsspt111_body}>

            <desc>111</desc>
            <g id="shape1472-679">
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53 Z" className={st14} />
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
            </g>
            <g id="shape1473-684" transform="translate(4.62992,-12.3431)">
            </g>
            <g id="shape1471-685">
              <text x="6.07" y="591.01" className={st3}>111</text>				</g>
          </g>
          <g id="spt111_body_2" transform="translate(-7.99361E-15,-10.6299)" className={clsspt111_body}>
            <desc>SPT</desc>
            <rect x="0" y="586.731" width="21.2598" height="7.79525" className={`${st16} ${clsspt111_path_2_1}`} />
            <text x="6.24" y="592.43" className={st3}>SPT</text>			</g>
        </g>
        <g id="spt108_group" transform="translate(1039.8,-160.986)" className={clsspt108_group}>
          <title>SPT108</title>
          <g id="spt108_body_1" transform="translate(0.354335,0)" className={clsspt108_body}>

            <desc>108</desc>
            <g id="shape1484-692">
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53 Z" className={st14} />
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
            </g>
            <g id="shape1485-697" transform="translate(4.62992,-12.3431)">
            </g>
            <g id="shape1483-698">
              <text x="6.07" y="591.01" className={st3}>108</text>				</g>
          </g>
          <g id="spt108_body_2" transform="translate(-7.99361E-15,-10.6299)" className={clsspt108_body}>
            <desc>SPT</desc>
            <rect x="0" y="586.731" width="21.2598" height="7.79525" className={`${st16} ${clsspt108_path_2_1}`} />
            <text x="6.24" y="592.43" className={st3}>SPT</text>			</g>
        </g>
        <g id="ssw102_group" transform="translate(1039.8,-118.466)" className={clsssw102_group}>
          <title>SSW102</title>
          <g id="ssw102_body_1" transform="translate(0.354335,0)" className={clsssw102_body}>

            <desc>102</desc>
            <g id="shape1490-705">
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53 Z" className={st14} />
              <path d="M10.63 594.53 A10.6299 10.6299 -180 0 0 10.63 573.27 A10.6299 10.6299 -180 1 0 10.63 594.53" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
              <path d="M0 583.9 L21.26 583.9" className={st5} />
            </g>
            <g id="shape1491-710" transform="translate(4.62992,-12.3431)">
            </g>
            <g id="shape1489-711">
              <text x="6.07" y="591.01" className={st3}>102</text>				</g>
          </g>
          <g id="ssw102_body_2" transform="translate(-7.99361E-15,-10.6299)" className={clsssw102_body}>
            <desc>SSW</desc>
            <rect x="0" y="586.731" width="21.2598" height="7.79525" className={`${st16} ${clsssw102_path_2_1}`} />
            <text x="5.2" y="592.43" className={st3}>SSW</text>			</g>
        </g>
        <g id="vmt104_group" transform="translate(126.734,372.95) rotate(-90)" className={clsvmt104_group}>
          <title>VMT104</title>
          <desc>VMT104</desc>
          <g id="vmt104_body_1" transform="translate(6.48425,-16.751)" className={clsvmt104_body}>
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53 Z" className={`${st4} ${clsvmt104_path_1_1}`} />
            <path d="M0 594.53 L8.65 594.53 L8.65 585.88 L0 585.88 L0 594.53" className={`${st5} ${clsvmt104_path_1_2}`} />
            <path d="M4.32 594.53 L4.32 600.47" className={`${st5} ${clsvmt104_path_1_3}`} />
          </g>
          <g id="vmt104_body_2" className={clsvmt104_body}>
            <path d="M0 589.12 L0 578.32 L21.61 589.12 L21.61 578.32 L0 589.12 Z" className={`${st2} ${clsvmt104_path_2_1}`} />
            <text x="587.6" y="-9.61" transform="rotate(90)" className={st3}>VMT104</text>			</g>
        </g>
        <g id="fuf101_vmt104_body" transform="translate(653.406,-384.835)" className={clsfuf101_vmt104_body}>
          <path d="M0 594.53 L30.06 594.53" className={`${st5} ${clsfuf101_all_lines}`} />
          <path d="M34.78 594.53 L57.05 594.53 L57.05 736.17" className={`${st5} ${clsfuf101_all_lines}`} />
        </g>
        <g id="shape1500-728" transform="translate(652.343,-384.923)">
          <desc>Filtrate</desc>
          <rect x="0" y="585.724" width="42.5197" height="8.80232" className={st16} />
          <text x="4" y="591.93" className={st12}>Filtrate</text>		</g>
        <g id="vhv1041512_body" transform="translate(1404.72,156.277) rotate(90)" className={clsvhv1041512_body}>
          <title>VHV105</title>
          <desc>VHV105</desc>
          <path d="M0 578.32 L0 589.12 L21.61 578.32 L21.61 589.12 L0 578.32 Z" className={`${st4} ${clsvhv1041512_path_1}`} />
          <path d="M0 578.32 L0 589.12 L21.61 578.32 L21.61 589.12 L0 578.32" className={`${st5} ${clsvhv1041512_path_2}`} />
          <path d="M10.81 583.72 L10.81 572.91" className={`${st5} ${clsvhv1041512_path_3}`} />
          <path d="M5.4 572.91 L16.21 572.91" className={`${st5} ${clsvhv1041512_path_4}`} />
          <text x="-607.73" y="12.61" transform="rotate(-90)" className={st3}>VHV105</text>		</g>
        <g id="samplewater_group" transform="translate(857.855,-392.01)" className={clssamplewater_group}>
          <title>Sample Water</title>
          <desc>SAMPLE WATER</desc>
          <g id="samplewater_body_1" transform="translate(21.2598,-10.6299)" className={clssamplewater_body}>
          </g>
          <g id="samplewater_body_2" className={clssamplewater_body}>
            <rect x="0" y="573.267" width="42.5197" height="21.2598" rx="10.6299" ry="10.6299" className={`${st2} ${clssamplewater_path_2_1}`} />
          </g>
          <g id="samplewater_body_3" className={clssamplewater_body}>
            <text x="11.3" y="582.1" className={st3}>SAMPLE  <tspan x="12.3" dy="1.2em" className={st6}>WATER</tspan></text>			</g>
        </g>
        <g id="vhv104_sample_body" transform="translate(821.005,-416.724)" className={clsvhv104_sample_body}>
          <path d="M0 594.62 L0 608.61 L33.83 608.61" className={`${st7} ${clsvhv104_sample_path_1}`} markerEnd="url(#arrow-right)" />
        </g>
        <g id="spt101_pressure_body" transform="translate(73.438,-396.396)" className={`${clsspt101_pressure_body} ${clsshow_sensor}`}>
          <title>{spt101_pressure_title}</title>
          <desc>SPT101_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clsspt101_pressure_path_1}`} />
          <text x="17.4" y="591.93" className={st17}>{spt101_pressure}</text>		</g>
        <g id="stu101_turbidity_body" transform="translate(115.745,-396.262)" className={`${clsstu101_turbidity_body} ${clsshow_sensor}`}>
          <title>{stu101_turbidity_title}</title>
          <desc>STU101_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clsstu101_turbidity_path_1}`} />
          <text x="17.02" y="591.93" className={st17}>{stu101_turbidity}</text>		</g>
        <g id="sct101_conductivity_body" transform="translate(140.548,-396.262)" className={`${clssct101_conductivity_body} ${clsshow_sensor}`}>
          <title>{sct101_conductivity_title}</title>
          <desc>SCT101_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clssct101_conductivity_path_1}`} />
          <text x="18.35" y="591.93" className={st17}>{sct101_conductivity}</text>		</g>
        <g id="sct101_totaldissolvedsolids_body" transform="translate(140.69,-404.333)" className={`${clssct101_totaldissolvedsolids_body} ${clsshow_sensor}`}>
          <title>{sct101_totaldissolvedsolids_title}</title>
          <desc>SCT101_2</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clssct101_totaldissolvedsolids_path_1}`} />
          <text x="18.35" y="591.93" className={st17}>{sct101_totaldissolvedsolids}</text>		</g>
        <g id="fsm101_pressurediff_body" transform="translate(169.249,-377.822)" className={`${clsfsm101_pressurediff_body} ${clsshow_sensor}`}>
          <title>{fsm101_pressurediff_title}</title>
          <desc>FSM101_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clsfsm101_pressurediff_path_1}`} />
          <text x="17.46" y="591.93" className={st17}>{fsm101_pressurediff}</text>		</g>
        <g id="spt105_pressure_body" transform="translate(197.383,-396.396)" className={`${clsspt105_pressure_body} ${clsshow_sensor}`}>
          <title>{spt105_pressure_title}</title>
          <desc>SPT105_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clsspt105_pressure_path_1}`} />
          <text x="17.4" y="591.93" className={st17}>{spt105_pressure}</text>		</g>
        <g id="spt112_pressure_body" transform="translate(197.383,-339.703)" className={`${clsspt112_pressure_body} ${clsshow_sensor}`}>
          <title>{spt112_pressure_title}</title>
          <desc>SPT112_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clsspt112_pressure_path_1}`} />
          <text x="17.4" y="591.93" className={st17}>{spt112_pressure}</text>		</g>
        <g id="vhv101_vmt101_body" transform="translate(79.7451,-356.577)" className={clsvhv101_vmt101_body}>
          <path d="M10.98 577.52 L10.98 594.53" className={`${st5} ${clsvhv101_vmt101_path_1}`} />
          <path d="M-0 594.53 L21.26 594.53" className={`${st5} ${clsvhv101_vmt101_path_2}`} />
        </g>
        <g id="vmt101_fsm101_body" transform="translate(122.265,-356.577)" className={clsvmt101_fsm101_body}>
          <path d="M10.63 577.52 L10.63 594.53" className={`${st5} ${clsvmt101_fsm101_path_1}`} />
          <path d="M35.61 577.52 L35.61 594.53" className={`${st5} ${clsvmt101_fsm101_path_2}`} />
          <path d="M0 594.53 L56.69 594.53" className={`${st5} ${clsvmt101_fsm101_path_3}`} />
        </g>
        <g id="fsm101_vfl101_body" transform="translate(193.131,-356.577)" className={clsfsm101_vfl101_body}>
          <path d="M21.44 577.52 L21.44 594.53" className={`${st5} ${clsfsm101_vfl101_path_1}`} />
          <path d="M0 594.53 L35.43 594.53" className={`${st5} ${clsfsm101_vfl101_path_2}`} />
        </g>
        <g id="par101_clp101_body" transform="translate(106.32,-299.884)" className={clspar101_clp101_body}>
          <path d="M0 594.53 L76.89 594.53" className={`${st5} ${clspar101_clp101_path_1}`} />
          <path d="M82.56 594.53 L129.33 594.53" className={`${st5} ${clspar101_clp101_path_2}`} />
          <path d="M108.25 577.52 L108.25 594.53" className={`${st5} ${clspar101_clp101_path_3}`} />
        </g>
        <g id="drain1_body" transform="translate(186.044,-143.978)" className={clsdrain1_body}>
          <title>DRAIN1</title>
          <path d="M0.00 516.57 L0.00 594.53" className={`${st5} ${clsdrain1_path_1}`} id="drain1_body_segment_1" /><path d="M113.39 516.57 L113.39 594.53" className={`${st5} ${clsdrain1_path_2}`} id="drain1_body_segment_2" /><path d="M325.98 516.93 L325.98 594.53" className={`${st5} ${clsdrain1_path_3}`} id="drain1_body_segment_3" /><path d="M375.59 516.93 L375.59 594.53" className={`${st5} ${clsdrain1_path_4}`} id="drain1_body_segment_4" /><path d="M456.38 516.93 L456.38 594.53" className={`${st5} ${clsdrain1_path_5}`} id="drain1_body_segment_5" /><path d="M499.78 516.93 L499.78 594.53" className={`${st5} ${clsdrain1_path_6}`} id="drain1_body_segment_6" /><path d="M637.80 523.66 L637.80 594.53" className={`${st5} ${clsdrain1_path_7}`} id="drain1_body_segment_7" /><path d="M0.00 594.53 L113.39 594.53" className={`${st5} ${clsdrain1_path_8}`} id="drain1_body_segment_8" /><path d="M113.39 594.53 L131.81 594.53" className={`${st5} ${clsdrain1_path_9}`} id="drain1_body_segment_9" /><path d="M137.48 594.53 L138.90 594.53" className={`${st5} ${clsdrain1_path_10}`} id="drain1_body_segment_10" /><path d="M144.57 594.53 L325.98 594.53" className={`${st5} ${clsdrain1_path_11}`} id="drain1_body_segment_11" /><path d="M325.98 594.53 L375.59 594.53" className={`${st5} ${clsdrain1_path_12}`} id="drain1_body_segment_12" /><path d="M375.59 594.53 L456.38 594.53" className={`${st5} ${clsdrain1_path_13}`} id="drain1_body_segment_13" /><path d="M456.38 594.53 L499.78 594.53" className={`${st5} ${clsdrain1_path_14}`} id="drain1_body_segment_14" /><path d="M499.78 594.53 L637.80 594.53" className={`${st5} ${clsdrain1_path_15}`} id="drain1_body_segment_15" /><path d="M637.80 594.53 L793.70 594.53" className={`${st5} ${clsdrain1_path_16}`} id="drain1_body_segment_16" /></g>
        <g id="drain2_body" transform="translate(710.454,-179.411)" className={clsdrain2_body}>
          <title>DRAIN2</title>
          <path d="M0.00 552.36 L0.00 594.53" className={`${st5} ${clsdrain2_path_1}`} id="drain2_body_segment_1" /><path d="M255.12 552.01 L255.12 594.53" className={`${st5} ${clsdrain2_path_2}`} id="drain2_body_segment_2" /><path d="M141.73 559.09 L141.73 594.53" className={`${st5} ${clsdrain2_path_3}`} id="drain2_body_segment_3" /><path d="M42.52 552.36 L42.52 594.53" className={`${st5} ${clsdrain2_path_4}`} id="drain2_body_segment_4" /><path d="M0.00 594.53 L42.52 594.53" className={`${st5} ${clsdrain2_path_5}`} id="drain2_body_segment_5" /><path d="M42.52 594.53 L141.73 594.53" className={`${st5} ${clsdrain2_path_6}`} id="drain2_body_segment_6" /><path d="M141.73 594.53 L255.12 594.53" className={`${st5} ${clsdrain2_path_7}`} id="drain2_body_segment_7" /><path d="M255.12 594.53 L269.29 594.53" className={`${st5} ${clsdrain2_path_8}`} id="drain2_body_segment_8" /></g>
        <g id="drain_output_body" transform="translate(1001,-143.978)" className={clsdrain_output_body}>
          <path d="M0 594.53 L14.17 594.53 L14.17 559.09 L0.35 559.09" className={`${st5} ${clsdrain_output_path_1}`} />
          <path d="M0 594.53 L77.95 594.53" className={`${st5} ${clsdrain_output_path_2}`} />
          <path d="M49.78 577.52 L49.78 594.53" className={`${st5} ${clsdrain_output_path_3}`} />
        </g>
        <g id="sump_body" transform="translate(324.41,-101.459)" className={clssump_body}>
          <title>SUMP</title>
          <path d="M726.38 577.52 L726.38 594.53" className={`${st5} ${clssump_path_1}`} />
          <path d="M0 580.35 L0 594.53 L754.55 594.53" className={`${st5} ${clssump_path_2}`} />
        </g>
        <g id="fsm102_fsm103_body" transform="translate(519.115,-306.97)" className={clsfsm102_fsm103_body}>
          <path d="M-0 594.53 L35.43 594.53" className={`${st5} ${clsfsm102_fsm103_path_1}`} />
          <path d="M17.72 594.53 L17.72 577.52" className={`${st5} ${clsfsm102_fsm103_path_2}`} />
        </g>
        <g id="vhv104_vnr107fuf101_body" transform="translate(602.737,-342.403)" className={clsvhv104_vnr107fuf101_body}>
          <path d="M-0 580.35 L39.86 580.35" className={`${st5} ${clsfuf101_all_lines}`} />
          <path d="M40.04 566.18 L39.69 594.53" className={`${st5} ${clsfuf101_all_lines}`} />
        </g>
        <g id="vnr108_vmt113uvm101_body" transform="translate(887.973,-436.301)" className={clsvnr108_vmt113uvm101_body}>
          <path d="M13.82 539.96 L13.82 594.53 L35.08 594.53" className={`${st5} ${clsvnr108_vmt113uvm101_path_1}`} />
          <path d="M0 560.87 L13.82 560.87 L13.82 594.53 L35.08 594.53" className={`${st5} ${clsvnr108_vmt113uvm101_path_2}`} />
        </g>
        <g id="pfl101_all_body" transform="translate(425.66,-285.711)" className={clspfl101_all_body}>
          {/* Main horizontal base - shared by paths 1,4,5,6 */}
          <path d="M0 544.92 L65.11 544.92" className={`${st5} ${clspfl101_all_path_1}`} />
          {/* Upward vertical - shared by paths 1,6 */}
          <path d="M65.11 544.92 L65.11 339.41" className={`${st5} ${clspfl101_all_path_7}`} />
          {/* Upper horizontal - shared by paths 1,6 */}
          <path d="M65.11 339.41 L341.49 339.41" className={`${st5} ${clspfl101_all_path_7}`} />
          {/* Path 1 continuation - right extension */}
          <path d="M341.49 339.41 L476.13 339.41" className={`${st5} ${clspfl101_all_path_8}`} />
          {/* Path 1 end - downward */}
          <path d="M476.13 339.41 L476.13 367.75" className={`${st5} ${clspfl101_all_path_8}`} />
          {/* Path 2 - vertical line */}
          <path d="M8.59 544.92 L8.59 527.91" className={`${st5} ${clspfl101_all_path_1}`} />
          {/* Path 3 - vertical line */}
          <path d="M36.94 544.92 L36.94 527.91" className={`${st5} ${clspfl101_all_path_1}`} />
          {/* Downward vertical - shared by paths 4,5 */}
          <path d="M65.11 544.92 L65.11 573.27" className={`${st5} ${clspfl101_all_path_1}`} />
          {/* Path 5 branch - horizontal right */}
          <path d="M65.11 573.27 L79.28 573.27" className={`${st5} ${clspfl101_all_path_1}`} />
          {/* Path 4 continuation - further down */}
          <path d="M65.11 573.27 L65.11 594.53" className={`${st5} ${clspfl101_all_path_1}`} />
          {/* Path 4 end - horizontal left */}
          <path d="M65.11 594.53 L54.66 594.53" className={`${st5} ${clspfl101_all_path_1}`} />
          {/* Path 6 end - downward */}
          <path d="M341.49 339.41 L341.49 367.75" className={`${st5} ${clspfl101_all_path_6}`} />
        </g>
        <g id="vmt117vmt118_pfl101_body" transform="translate(373.662,-321.144)" className={clsvmt117vmt118_pfl101_body}>
          <path d="M0 594.53 L0 580.35 L19.58 580.35" className={`${st5} ${clsvmt117vmt118_pfl101_path_1}`} />
          <path d="M0 566.18 L0 580.35 L19.58 580.35" className={`${st5} ${clsvmt117vmt118_pfl101_path_2}`} />
        </g>
        <g id="tnk101_volume_body" transform="translate(251.383,-371.6)" className={`${clstnk101_volume_body} ${clsshow_sensor}`}>
          <title>{tnk101_volume_title}</title>
          <desc>TNK101_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clstnk101_volume_path_1}`} />
          <text x="17.83" y="591.93" className={st17}>{tnk101_volume}</text>		</g>
        <g id="spt103_pressure_body" transform="translate(324.588,-325.53)" className={`${clsspt103_pressure_body} ${clsshow_sensor}`}>
          <title>{spt103_pressure_title}</title>
          <desc>SPT103_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clsspt103_pressure_path_1}`} />
          <text x="17.4" y="591.93" className={st17}>{spt103_pressure}</text>		</g>
        <g id="spt102_pressure_body" transform="translate(416.643,-374.853)" className={`${clsspt102_pressure_body} ${clsshow_sensor}`}>
          <title>{spt102_pressure_title}</title>
          <desc>SPT102_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clsspt102_pressure_path_1}`} />
          <text x="17.4" y="591.93" className={st17}>{spt102_pressure}</text>		</g>
        <g id="sft101_flowrate_body" transform="translate(445.343,-374.853)" className={`${clssft101_flowrate_body} ${clsshow_sensor}`}>
          <title>{sft101_flowrate_title}</title>
          <desc>SFT101_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clssft101_flowrate_path_1}`} />
          <text x="17.57" y="591.93" className={st17}>{sft101_flowrate}</text>		</g>
        <g id="tnk102_volume_body" transform="translate(251.95,-585.474)" className={`${clstnk102_volume_body} ${clsshow_sensor}`}>
          <title>{tnk102_volume_title}</title>
          <desc>TNK102_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clstnk102_volume_path_1}`} />
          <text x="17.83" y="591.93" className={st17}>{tnk102_volume}</text>		</g>
        <g id="spt106_pressure_body" transform="translate(324.8,-516.585)" className={`${clsspt106_pressure_body} ${clsshow_sensor}`}>
          <title>{spt106_pressure_title}</title>
          <desc>SPT106_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clsspt106_pressure_path_1}`} />
          <text x="17" y="591.93" className={st17}>{spt106_pressure}</text>		</g>
        <g id="spt104_pressure_body" transform="translate(519.824,-346.939)" className={`${clsspt104_pressure_body} ${clsshow_sensor}`}>
          <title>{spt104_pressure_title}</title>
          <desc>SPT104_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clsspt104_pressure_path_1}`} />
          <text x="17.4" y="591.93" className={st17}>{spt104_pressure}</text>		</g>
        <g id="fsm102_pressurediff_body" transform="translate(495.021,-327.932)" className={`${clsfsm102_pressurediff_body} ${clsshow_sensor}`}>
          <title>{fsm102_pressurediff_title}</title>
          <desc>FSM102_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clsfsm102_pressurediff_path_1}`} />
          <text x="17.46" y="591.93" className={st17}>{fsm102_pressurediff}</text>		</g>
        <g id="fsm102_pressurediff_body" transform="translate(544.769,-327.798)" className={`${clsfsm102_pressurediff_body} ${clsshow_sensor}`}>
          <title>{fsm102_pressurediff_title}</title>
          <desc>FSM103_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clsfsm102_pressurediff_path_1}`} />
          <text x="17.46" y="591.93" className={st17}>{fsm103_pressurediff}</text>		</g>
        <g id="spt107_pressure_body" transform="translate(601.249,-347.073)" className={`${clsspt107_pressure_body} ${clsshow_sensor}`}>
          <title>{spt107_pressure_title}</title>
          <desc>SPT107_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clsspt107_pressure_path_1}`} />
          <text x="17.4" y="591.93" className={st17}>{spt107_pressure}</text>		</g>
        <g id="spt108_pressure_body" transform="translate(1033.6,-183.663)" className={`${clsspt108_pressure_body} ${clsshow_sensor}`}>
          <title>{spt108_pressure_title}</title>
          <desc>SPT108_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clsspt108_pressure_path_1}`} />
          <text x="17.4" y="591.93" className={st17}>{spt108_pressure}</text>		</g>
        <g id="spt111_pressure_body" transform="translate(934.249,-523.821)" className={`${clsspt111_pressure_body} ${clsshow_sensor}`}>
          <title>{spt111_pressure_title}</title>
          <desc>SPT111_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clsspt111_pressure_path_1}`} />
          <text x="17.4" y="591.93" className={st17}>{spt111_pressure}</text>		</g>
        <g id="uvm101_status_body" transform="translate(911.714,-395.829)" className={`${clsuvm101_status_body} ${clsshow_sensor}`}>
          <title>{uvm101_status_title}</title>
          <desc>UVM101_1</desc>
          <rect x="0" y="585.724" width="36.8504" height="8.80232" className={`${st16} ${clsuvm101_status_path_1}`} />
          <text x="17.66" y="591.93" className={st17}>{uvm101_status}</text>		</g>
        <g id="uvm101_dose_body" transform="translate(911.714,-387.325)" className={`${clsuvm101_dose_body} ${clsshow_sensor}`}>
          <title>{uvm101_dose_title}</title>
          <desc>UVM101_2</desc>
          <rect x="0" y="585.724" width="36.8504" height="8.80232" className={`${st16} ${clsuvm101_dose_path_1}`} />
          <text x="17.66" y="591.93" className={st17}>{uvm101_dose}</text>		</g>
        <g id="stu102_turbidity_body" transform="translate(798.328,-509.648)" className={`${clsstu102_turbidity_body} ${clsshow_sensor}`}>
          <title>{stu102_turbidity_title}</title>
          <desc>STU102_1</desc>
          <rect x="0" y="585.724" width="36.8504" height="8.80232" className={`${st16} ${clsstu102_turbidity_path_1}`} />
          <text x="17.08" y="591.93" className={st17}>{stu102_turbidity}</text>		</g>
        <g id="spt110_pressure_body" transform="translate(692.029,-509.648)" className={`${clsspt110_pressure_body} ${clsshow_sensor}`}>
          <title>{spt110_pressure_title}</title>
          <desc>SPT110_1</desc>
          <rect x="0" y="585.724" width="36.8504" height="8.80232" className={`${st16} ${clsspt110_pressure_path_1}`} />
          <text x="17.46" y="591.93" className={st17}>{spt110_pressure}</text>		</g>
        <g id="sct102_conductivity_body" transform="translate(724.91,-510.215)" className={`${clssct102_conductivity_body} ${clsshow_sensor}`}>
          <title>{sct102_conductivity_title}</title>
          <desc>SCT102_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clssct102_conductivity_path_1}`} />
          <text x="17.35" y="591.93" className={st17}>{sct102_conductivity}</text>		</g>
        <g id="sct102_totaldissolvedsolids_body" transform="translate(725.052,-518.286)" className={`${clssct102_totaldissolvedsolids_body} ${clsshow_sensor}`}>
          <title>{sct102_totaldissolvedsolids_title}</title>
          <desc>SCT102_2</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clssct102_totaldissolvedsolids_path_1}`} />
          <text x="17.35" y="591.93" className={st17}>{sct102_totaldissolvedsolids}</text>		</g>
        <g id="tnk101_vmt118_body" transform="translate(306.517,-279.191)" className={clstnk101_vmt118_body}>
          <path d="M35.61 571 L35.61 589.14 L24.09 589.14" className={`${st5} ${clstnk101_vmt118_path_1}`} />
          <path d="M18.43 589.14 L17.01 589.14" className={`${st5} ${clstnk101_vmt118_path_2}`} />
          <path d="M11.34 589.14 L0 589.14" className={`${st5} ${clstnk101_vmt118_path_3}`} />
          <path d="M0 594.53 L11.34 594.53" className={`${st5} ${clstnk101_vmt118_path_4}`} />
          <path d="M17.01 594.53 L18.43 594.53" className={`${st5} ${clstnk101_vmt118_path_5}`} />
          <path d="M24.09 594.53 L67.5 594.53 L67.5 574.19" className={`${st5} ${clstnk101_vmt118_path_6}`} />
        </g>
        <g id="tnk102_vnr102_body" transform="translate(299.43,-413.27)" className={clstnk102_vnr102_body}>
          <path d="M42.7 513.74 L42.7 530.46 L31.18 530.46" className={`${st5} ${clstnk102_vnr102_path_1}`} />
          <path d="M25.51 530.46 L7.09 530.46" className={`${st5} ${clstnk102_vnr102_path_2}`} />
          <path d="M0 555.55 L0 594.53 L25.51 594.53" className={`${st5} ${clstnk102_vnr102_path_3}`} />
          <path d="M31.18 594.53 L35.43 594.53" className={`${st5} ${clstnk102_vnr102_path_4}`} />
        </g>
        <g id="vnr102vnr104_vmt117_body" transform="translate(356.477,-371.104)" className={clsvnr102vnr104_vmt117_body}>
          <path d="M17.53 538.19 L17.53 549.06 L17.54 549.06 L17.54 591.51" className={`${st7} ${clsvnr102vnr104_vmt117_path_1}`} markerEnd="url(#arrow-right)" />
          <path d="M0 552.36 L17.54 552.36 L17.54 590.25" className={`${st7} ${clsvnr102vnr104_vmt117_path_2}`} />
        </g>
        <g id="fuf101_tmp_body" transform="translate(595.336,-419.663)" className={`${clsfuf101_tmp_body} ${clsshow_sensor}`}>
          <title>{fuf101_tmp_title}</title>
          <desc>FUF101_1</desc>
          <rect x="0" y="585.724" width="38.5827" height="8.80232" className={`${st16} ${clsfuf101_tmp_path_1}`} />
          <text x="10.07" y="591.93" className={st17}>{fuf101_tmp}</text>		</g>
        <g id="fuf101_tcsf_body" transform="translate(595.336,-410.137)" className={`${clsfuf101_tcsf_body} ${clsshow_sensor}`}>
          <title>{fuf101_tcsf_title}</title>
          <desc>FUF101_2</desc>
          <rect x="0" y="585.724" width="38.5827" height="8.80232" className={`${st16} ${clsfuf101_tcsf_path_1}`} />
          <text x="10.07" y="591.93" className={st17}>{fuf101_tcsf}</text>		</g>
        <g id="fcb101_pressurediff_body" transform="translate(826.958,-490.924)" className={`${clsfcb101_pressurediff_body} ${clsshow_sensor}`}>
          <title>{fcb101_pressurediff_title}</title>
          <desc>FCB101_1</desc>
          <rect x="0" y="585.724" width="36.8504" height="8.80232" className={`${st16} ${clsfcb101_pressurediff_path_1}`} />
          <text x="17.24" y="591.93" className={st17}>{fcb101_pressurediff}</text>		</g>
        <g id="pfl101_speed_body" transform="translate(392.123,-347.357)" className={`${clspfl101_speed_body} ${clsshow_sensor}`}>
          <title>{pfl101_speed_title}</title>
          <desc>PFL101_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clspfl101_speed_path_1}`} />
          <text x="17.6" y="591.93" className={st17}>{pfl101_speed}</text>		</g>
        <g id="pch101_speed_body" transform="translate(377.95,-498.727)" className={`${clspch101_speed_body} ${clsshow_sensor}`}>
          <title>{pch101_speed_title}</title>
          <desc>PCH101_1</desc>
          <rect x="0" y="585.724" width="34.7244" height="8.80232" className={`${st16} ${clspch101_speed_path_1}`} />
          <text x="17.77" y="591.93" className={st17}>{pch101_speed}</text>		</g>
        <g id="shape1570-931" transform="translate(604.509,-243.191)">
          <path d="M0 530.75 L37.91 530.75 L37.91 594.53" className={`${st5} ${clsfuf101_all_lines}`} />
          <path d="M14 530.75 L14 513.74" className={`${st5} ${clsfuf101_all_lines}`} />
          <path d="M0 530.75 L37.91 530.75 L37.91 516.57" className={`${st5} ${clsfuf101_all_lines}`} />
        </g>
        <g id="air_tnk101_body" transform="translate(852.753,-229.018)" className={clsair_tnk101_body}>
          <title>AIR RELEASE INTO TNK101</title>
          <desc>*AIR RELEASE INTO TNK101*</desc>
          <path d="M0 594.53 L0 573.27 L-71.25 573.27" className={`${st7} ${clsair_tnk101_path_1}`} markerEnd="url(#arrow-right)" />
          <rect x="-71.2992" y="562.58" width="71.7325" height="7.20016" className={`${st9} ${clsair_tnk101_path_2}`} />
          <text x="-71.3" y="567.98" className={st11}>*AIR RELEASE INTO TNK101*</text>		</g>
        <g id="air_tnk101_1_body" transform="translate(824.406,-221.931)" className={clsair_tnk101_1_body}>
          <path d="M0 587.44 L0 566.18 L28.35 566.18 L28.35 587.44" className={`${st5} ${clsair_tnk101_1_path_1}`} />
        </g>
        <g id="air_tnk101_2_body" transform="translate(190.296,-412.986)" className={clsair_tnk101_2_body}>
          <title>AIR INLET FROM VAR101 &amp; VAR102</title>
          <path d="M0 594.53 L96.73 594.53 L96.73 640.83" className={`${st7} ${clsair_tnk101_2_path_1}`} markerEnd="url(#arrow-right)" />
          <rect x="0.99525" y="583.557" width="94.3877" height="7.20016" className={`${st9} ${clsair_tnk101_2_path_2}`} />
          <text x="1" y="588.96" className={st11}>*AIR INLET FROM VAR101 &amp; VAR102*</text>		</g>
        <g id="dynamicconnector1574_body" transform="translate(1045.51,-402.817)" className={clsdynamicconnector1574_body}>
          <path d="M-1.98 594.53 L-12.19 594.53 L-12.19 513.21" className={`${st5} ${clsdynamicconnector1574_path_1}`} />
        </g>
        <g id="junction1583_body" transform="translate(949.981,-482.718)" className={clsjunction1583_body}>
        </g>
        <g id="junction1585_body" transform="translate(962.737,-482.718)" className={clsjunction1585_body}>
        </g>
        <g id="var103_body" transform="translate(243.822,73.5405) rotate(-90)" className={clsvar103_body}>
          <title>VAR103</title>
          <desc>VAR103</desc>
          <path d="M0 590.98 L0 583.9 L10.63 580.35 L14.17 580.35 L14.17 594.53 L10.63 594.53 L0 590.98 Z" className={`${st4} ${clsvar103_path_1}`} />
          <path d="M0 590.98 L0 583.9 L10.63 580.35 L14.17 580.35 L14.17 594.53 L10.63 594.53 L0 590.98" className={`${st5} ${clsvar103_path_2}`} />
          <path d="M10.63 594.53 L10.63 580.35" className={`${st5} ${clsvar103_path_3}`} />
          <text x="559.39" y="-6.42" transform="rotate(90)" className={st3}>VAR103</text>		</g>
        <g id="vmt112_fcb101vhv105_body" transform="translate(802.934,-438.25)" className={clsvmt112_fcb101vhv105_body}>
          <path d="M28.33 511.79 L28.27 562.81" className={`${st5} ${clsvmt112_fcb101vhv105_path_1}`} />
          <path d="M0 562.81 L35.08 562.81" className={`${st5} ${clsvmt112_fcb101vhv105_path_2}`} />
          <path d="M14 545.81 L14 562.81" className={`${st5} ${clsvmt112_fcb101vhv105_path_3}`} />
          <path d="M35.08 562.81 L18.07 562.81 L18.07 594.53" className={`${st5} ${clsvmt112_fcb101vhv105_path_4}`} />
        </g>
        <g id="uvm101_vmt114vmt116_body" transform="translate(937.225,-243.191)" className={clsuvm101_vmt114vmt116_body}>
          <path d="M26.93 353.58 L42.8 353.58" className={`${st5} ${clsuvm101_vmt114vmt116_path_1}`} />
          <path d="M42.52 332.68 L42.8 353.58" className={`${st5} ${clsuvm101_vmt114vmt116_path_2}`} />
          <path d="M14.35 336.57 L14.17 353.58" className={`${st5} ${clsuvm101_vmt114vmt116_path_3}`} />
          <path d="M-0 353.58 L14.17 353.58" className={`${st5} ${clsuvm101_vmt114vmt116_path_4}`} />
          <path d="M14.17 353.58 L26.93 353.58" className={`${st5} ${clsuvm101_vmt114vmt116_path_5}`} />
          <path d="M28.35 594.53 L26.93 353.58 L26.93 353.58" className={`${st5} ${clsuvm101_vmt114vmt116_path_6}`} />
          <path d="M42.8 353.58 L63.43 353.58" className={`${st5} ${clsuvm101_vmt114vmt116_path_7}`} />
        </g>
        <g id="aux_components_body" transform="translate(0.374996,-0.12)" className={clsaux_components_body}>
          <title>Aux Components</title>
          <path d="M28.78 594.53 L1089.42 594.53 A33.0994 33.0994 -180 0 0 1122.52 561.43 L1122.52 555.28 A28.7821 28.7821 -180        0 0 1093.74 526.5 L28.78 526.5 A28.7821 28.7821 -180 0 0 0 555.28 L0 565.74 A28.7821 28.7821 -180 0 0 28.78        594.53 Z" className={`${st18} ${clsaux_components_path_1}`} />
        </g>
        <g id="input_water_temp_body" transform="translate(476.64,-38.5232)" className={clsinput_water_temp_body}>
          <title>Input Water Temperature</title>
          <desc>Input Water Temperature</desc>
          <rect x="0" y="574.527" width="139.047" height="20" className={`${st19} ${clsinput_water_temp_path_1}`} />
          <text x="5.18" y="588.13" className={st20}>Input Water Temperature</text>		</g>
        <g id="process_water_temp_body" transform="translate(644.792,-38.5232)" className={clsprocess_water_temp_body}>
          <title>Process Water Temperature</title>
          <desc>Process Water Temperature</desc>
          <rect x="0" y="574.527" width="149.018" height="20" className={`${st19} ${clsprocess_water_temp_path_1}`} />
          <text x="4.63" y="588.13" className={st20}>Process Water Temperature</text>		</g>
        <g id="enclosure_temp_body" transform="translate(319.622,-38.5232)" className={clsenclosure_temp_body}>
          <title>Enclosure Temperature</title>
          <desc>Enclosure Temperature</desc>
          <rect x="0" y="574.527" width="127.913" height="20" className={`${st19} ${clsenclosure_temp_path_1}`} />
          <text x="5.82" y="588.13" className={st20}>Enclosure Temperature</text>		</g>
        <g id="enclosure_sump_body" transform="translate(122.265,-38.5232)" className={clsenclosure_sump_body}>
          <title>Enclosure Sump</title>
          <desc>Enclosure Sump</desc>
          <rect x="0" y="574.527" width="175.181" height="20" className={`${st19} ${clsenclosure_sump_path_1}`} />
          <text x="47.95" y="588.13" className={st20}>Enclosure Sump</text>		</g>
        <g id="enclosure_door_body" transform="translate(8.87894,-38.5231)" className={clsenclosure_door_body}>
          <title>Enclosure Door</title>
          <desc>Enclosure Door</desc>
          <rect x="0" y="574.527" width="89.2913" height="20" className={`${st19} ${clsenclosure_door_path_1}`} />
          <text x="6.8" y="588.13" className={st20}>Enclosure Door</text>		</g>
        <g id="power_consumption_body" transform="translate(822.916,-38.5232)" className={clspower_consumption_body}>
          <title>Power Consumption</title>
          <desc>System Power Consumption</desc>
          <rect x="0" y="574.527" width="149.018" height="20" className={`${st19} ${clspower_consumption_path_1}`} />
          <text x="4.37" y="588.13" className={st20}>System Power Consumption</text>		</g>
        <g id="air_con_body" transform="translate(1001.04,-38.5232)" className={clsair_con_body}>
          <title>Air Conditioner</title>
          <desc>Air Conditioner</desc>
          <rect x="0" y="574.527" width="113.352" height="20" className={`${st19} ${clsair_con_path_1}`} />
          <text x="18.61" y="588.13" className={st20}>Air Conditioner</text>		</g>
        <g id="input_water_temp_1_body" transform="translate(476.64,-12.583)" className={clsinput_water_temp_1_body}>
          <title>Input Water Temperature</title>
          <desc>stt102_temperature</desc>
          <rect x="0" y="574.527" width="139.047" height="20" className={`${st19} ${clsinput_water_temp_1_path_1}`} />
          <text x="65.05" y="588.13" textAnchor="middle" className={st21}>{stt102_temperature}</text>		</g>
        <g id="process_water_temp_1_body" transform="translate(644.792,-12.583)" className={clsprocess_water_temp_1_body}>
          <title>Process Water Temperature</title>
          <desc>stt103_temperature</desc>
          <rect x="0" y="574.527" width="149.018" height="20" className={`${st19} ${clsprocess_water_temp_1_path_1}`} />
          <text x="67.03" y="588.13" textAnchor="middle" className={st21}>{stt103_temperature}</text>		</g>
        <g id="enclosure_temp_1_body" transform="translate(319.622,-12.583)" className={clsenclosure_temp_1_body}>
          <title>Enclosure Temperature</title>
          <desc>stt101_temperature</desc>
          <rect x="0" y="574.527" width="127.913" height="20" className={`${st19} ${clsenclosure_temp_1_path_1}`} />
          <text x="63.96" y="588.13" textAnchor="middle" className={st21}>{stt101_temperature}</text>		</g>
        <g id="enclosure_sump_1_body" transform="translate(127.275,-12.583)" className={clsenclosure_sump_1_body}>
          <title>Enclosure Sump</title>
          <desc>enc101_leak</desc>
          <rect x="0" y="574.527" width="163.242" height="20" className={`${st19} ${clsenclosure_sump_1_path_1}`} />
          <text x="81.43" y="588.13" textAnchor="middle" className={st21}>{enc101_leak}</text>		</g>
        <g id="enclosure_door_1_body" transform="translate(0.375,-12.583)" className={clsenclosure_door_1_body}>
          <title>Enclosure Door</title>
          <desc>enc101_dooropen</desc>
          <rect x="0" y="574.527" width="104.882" height="20" className={`${st19} ${clsenclosure_door_1_path_1}`} />
          <text x="49.44" y="588.13" textAnchor="middle" className={st21}>{enc101_dooropen}</text>		</g>
        <g id="power_consumption_1_body" transform="translate(822.916,-12.583)" className={clspower_consumption_1_body}>
          <title>Power Consumption</title>
          <desc>sjt101_power</desc>
          <rect x="0" y="574.527" width="149.018" height="20" className={`${st19} ${clspower_consumption_1_path_1}`} />
          <text x="72.72" y="588.13" textAnchor="middle" className={st21}>{sjt101_power}</text>		</g>
        <g id="air_con_1_body" transform="translate(1001.04,-12.583)" className={clsair_con_1_body}>
          <title>Air Conditioner</title>
          <desc>acu101_cooling</desc>
          <rect x="0" y="574.527" width="113.352" height="20" className={`${st19} ${clsair_con_1_path_1}`} />
          <text x="55.59" y="588.13" textAnchor="middle" className={st21}>{acu101_cooling}</text>		</g>
        <g id="uvm101_uvt_body" transform="translate(911.714,-378.224)" className={`${clsuvm101_uvt_body} ${clsshow_sensor}`}>
          <title>{uvm101_uvt_title}</title>
          <desc>UVM101_3</desc>
          <rect x="0" y="585.724" width="36.8504" height="8.80232" className={`${st16} ${clsuvm101_uvt_path_1}`} />
          <text x="17.66" y="591.93" className={st17}>{uvm101_uvt}</text>		</g>
        <g id="uvm101_lampliferemaining_body" transform="translate(911.714,-369.124)" className={`${clsuvm101_lampliferemaining_body} ${clsshow_sensor}`}>
          <title>{uvm101_lampliferemaining_title}</title>
          <desc>UVM101_4</desc>
          <rect x="0" y="585.724" width="36.8504" height="8.80232" className={`${st16} ${clsuvm101_lampliferemaining_path_1}`} />
          <text x="17.66" y="591.93" className={st17}>{uvm101_lampliferemaining}</text>		</g>
        <g id="dynamicconnector1680_body" transform="translate(653.406,-462.566)" className={clsdynamicconnector1680_body}>
          <path d="M0 587.75 L30.06 587.6" className={`${st5} ${clsfuf101_all_lines}`} />
          <path d="M34.78 587.58 L127.91 587.13" className={`${st5} ${clsfuf101_all_lines}`} />
        </g>
        <g id="shape1683-1034" transform="translate(1337.05,106.848) rotate(90)">
          <path d="M0 594.53 L17.9 594.53" className={`${st5} ${clsfuf101_all_lines}`} />
        </g>
        <g id="shape1684-1037" transform="translate(1305.16,107.556) rotate(90)">
          <path d="M0 594.53 L17.35 594.53" className={`${st5} ${clsfuf101_all_lines}`} />
        </g>
        <g id="shape1685-1040" transform="translate(1361.67,103.659) rotate(90)">
          <path d="M0 594.53 L20.97 594.53" className={`${st5} ${clsfuf101_all_lines}`} />
        </g>
        <g id="shape1686-1043" transform="translate(158.447,351.336) rotate(-90)">
          <path d="M0 594.53 L226.63 594.53" className={`${st5} ${clsfuf101_all_lines}`} />
        </g>
        <g id="group1689-1046" transform="translate(726.145,-360.098)">
          <g id="shape1687-1047" transform="translate(41.0017,1189.03) rotate(180)">
            <path d="M0 594.53 L41 594.53" className={`${st5} ${clsfuf101_all_lines}`} />
          </g>
          <g id="shape1688-1050" transform="translate(-594.527,594.527) rotate(-90)">
            <path d="M0 594.53 L109.6 594.53" className={`${st5} ${clsfuf101_all_lines}`} />
          </g>
        </g>
      </g>
    </svg>

  );




};

export default DeviceSchematicAlpha2SvgVer4;
